// noinspection SqlDialectInspection

const Labels = {
  Ascending: 'Ascending',
  Access: 'Access',
  Account: 'Account',
  AccountCancelled: 'Account cancelled',
  AccountId: 'Account ID',
  AccountSettings: 'Account settings',
  AccessTokenUrl: 'Access token URL',
  Action: 'Action',
  ActionType: 'Action type',
  Actions: 'Actions',
  ActionSettings: 'Action settings',
  Active: 'Active',
  Activate: 'Activate',
  ActiveUsers: 'Active users',
  ApiRoutes: 'API routes',
  Add: 'Add',
  AddAction: 'Add action',
  AddActions: 'Add actions',
  AddAdvancedSearchField: 'Add advanced search field',
  AddAnotherField: 'Add another field',
  AddAnotherFilter: 'Add another filter',
  AddApiUser: 'Add API user',
  AddApiUserToken: 'Add an API token',
  AddApp: 'Add app',
  AddBaseEntityRestriction: 'Add base list restriction',
  AddCalculation: 'Add calculation',
  AddCalculatedColumn: 'Add calculated column',
  AddCalculatedField: 'Add calculated field',
  AddCalculatedFields: 'Add calculated fields',
  AddCalculatedRow: 'Add calculated row',
  AddColor: 'Add color',
  AddColors: 'Add colors',
  AddColorCodingRule: 'Add color coding rule',
  AddColorGradient: 'Add color gradient',
  AddColumn: 'Add column',
  AddCompany: 'Add {0}',
  AddCompanyMapping: 'Add {0} mapping',
  AddCompareFromEntityRestriction: 'Add compare from list restriction',
  AddCompareToEntityRestriction: 'Add compare to list restriction',
  AddConnector: 'Add connector',
  AddConnection: 'Add connection',
  AddCreditCard: 'Add credit card',
  AddCustomAction: 'Add custom action',
  AddCustomEntity: 'Add custom list',
  AddCustomEntityCompare: 'Compare lists',
  AddCustomEntityJoin: 'Join lists',
  AddCustomEntityMerge: 'Merge lists',
  AddCustomEntityRestriction: 'Restrict data in a list',
  AddCustomEntitySummary: 'Summarize a list',
  AddCustomEntityMatrix: 'Summarize fields in a matrix',
  AddDashboard: 'Add dashboard',
  AddDataSourceFile: 'Add file data source',
  AddDataSourceFolder: 'Add folder data source',
  AddDataSourceQuery: 'Add query data source',
  AddDefaultColumn: 'Add default column',
  AddDefaultFields: 'Add default fields',
  AddDependency: 'Add dependency',
  AddDomainRestriction: 'Add domain restriction',
  AddDimensions: 'Add dimensions',
  AddDynamicRow: 'Add dynamic row',
  AddEndpoint: 'Add endpoint',
  AddDetail: 'Add detail',
  AddImage: 'Add image',
  AddEntities: 'Add lists',
  AddEntity: 'Add list',
  AddEntityAction: 'Add list action',
  AddEnvironmentParameter: 'Add environment parameter',
  AddErrorCode: 'Add error code',
  AddFavorite: 'Add favorite',
  AddFavorites: 'Add favorites',
  AddField: 'Add field',
  AddFields: 'Add fields',
  AddFile: 'Add file',
  AddFileSplit: 'Add file split',
  AddFilter: 'Add filter',
  AddFilterColumn: 'Add filter column',
  AddFilterOnField: 'Add filter on field',
  AddFilterRow: 'Add filter row',
  AddFilterVariable: 'Add filter variable',
  AddFirewall: 'Add firewall',
  AddFiscalPeriod: 'Add fiscal period',
  AddFiscalYear: 'Add fiscal year',
  AddFiscalYears: 'Add fiscal years',
  AddWidgetFirewall: 'Add widget firewall',
  AddFolder: 'Add folder',
  AddForm: 'Add form',
  AddFormItem: 'Add form item',
  AddFlow: 'Add flow',
  AddFunction: 'Add function',
  AddGlobalVariable: 'Add global variable',
  AddGradient: 'Add gradient',
  AddGroup: 'Add group',
  AddGroupField: 'Add group field',
  AddHeader: 'Add header',
  AddHiddenField: 'Add hidden field',
  AddHomePageItem: 'Add item to home page',
  AddInsight: 'Add insight',
  AddIpAddress: 'Add IP address',
  AddItem: 'Add item',
  AdditionalFilters: 'Additional filters',
  AddJob: 'Add job',
  AddJoin: 'Add join',
  AddJoiningFields: 'Add joining fields',
  AddKeyField: 'Add key field',
  AddLabelColumn: 'Add label column',
  AddListItem: 'Add list item',
  AddListItems: 'Add list items',
  AddLookup: 'Add lookup',
  AddMapping: 'Add mapping',
  AddMatchingFields: 'Add matching fields',
  AddMultipleListItems: 'Add multiple list items',
  AddNewItem: 'Add new item',
  AddNewTab: 'Add new tab',
  AddOptimization: 'Add optimization',
  AddParameter: 'Add parameter',
  AddParentField: 'Add parent field',
  AddPage: 'Add page',
  AddRelatedFields: 'Add related fields',
  AddRelationship: 'Add relationship',
  AddReportingTree: 'Add reporting tree',
  AddResource: 'Add resource',
  AddResources: 'Add resources',
  AddSearchField: 'Add search field',
  AddTextSearchField: 'Add text search field',
  Address: 'Address',
  AddressType: 'Address type',
  AddRestriction: 'Add restriction',
  AddRole: 'Add role',
  AddRow: 'Add row',
  AddSandbox: 'Add sandbox',
  AddScript: 'Add script',
  AddSelected: 'Add selected',
  AddSelectedColumn: 'Add selected column',
  AddSelectedColumns: 'Add selected columns',
  AddSidebar: 'Add sidebar',
  AddSort: 'Add sort',
  AddSplitFile: 'Add split file',
  AddSuggestion: 'Add suggestion',
  AddSummaryColumn: 'Add summary column',
  AddSummaryFields: 'Add summary fields',
  AddSummaryRow: 'Add summary row',
  AddTab: 'Add tab',
  AddTable: 'Add table',
  AddTables: 'Add tables',
  AddTag: 'Add tag',
  AddTeam: 'Add team',
  AddTeams: 'Add teams',
  AddToHomePage: 'Add to home page',
  AddToken: 'Add token',
  AddUrl: 'Add URL',
  AddUrlParameter: 'Add URL parameter',
  AddUser: 'Add user',
  AddUsers: 'Add users',
  AddVariable: 'Add variable',
  AddWidget: 'Add widget',
  AddVirtualNetwork: 'Add virtual network',
  Administrator: 'Administrator',
  Admin1: 'Administrator 1',
  Admin2: 'Administrator 2',
  AdvancedSearch: 'Advanced search',
  Alias: 'Alias',
  All: 'All',
  AllCategories: 'All categories',
  AllCertifications: 'All certifications',
  AllConnectors: 'All connectors',
  AllCustomEntityTypes: 'All custom list types',
  AllFieldTypes: 'All field types',
  AllGroups: 'All groups',
  AllowedAuthenticatorApps: 'Allowed authenticator apps',
  AllowMultipleValues: 'Allow multiple values to be selected',
  AllowTokenAsQueryParameter: 'Allow token to be sent as a query parameter',
  AllowUserTokensForEndpoint: 'Allow user tokens to access this endpoint',
  AllPeriods: 'All periods',
  AllStatuses: 'All statuses',
  AllUsers: 'All users',
  AltTextField: 'Alt text field',
  ApiEndpoint: 'API endpoint',
  ApiEndpoints: 'API endpoints',
  ApiUser: 'API user',
  ApiUsers: 'API users',
  App: 'App',
  AppendListItems: 'Append to existing list items',
  Application: 'Application',
  AppliesTo: 'Applies to',
  Apps: 'Apps',
  AppSettings: 'App settings',
  AppStore: 'App store',
  AppSubmissions: 'App submissions',
  AppType: 'App type',
  AsRequestParameter: 'As request URL parameter',
  AsRequestHeader: 'As request header',
  AssignedTo: 'Assigned to user',
  AssignUser: 'Assign user',
  AttachedTo: 'Attached to',
  Authentication: 'Authentication',
  AuthenticationMethod: 'Authentication method',
  AuthenticationMethodBasic: 'Basic authentication',
  AuthenticationMethodBearerToken: 'Bearer token',
  AuthenticationMethodNone: 'None',
  AuthenticationMethodOAuth1: 'OAuth 1.0',
  AuthenticationMethodOAuth2: 'OAuth 2.0',
  AuthenticationMethodExchangeToken: 'Exchange token',
  Author: 'Author',
  AuthorizationUrl: 'Authorization URL',
  AuditLogDetails: 'Audit log details',
  Authorize: 'Authorize',
  Availability: 'Availability',
  Back: 'Back',
  BackgroundColor: 'Background color',
  BaseEntity: 'Base list',
  BaseEntityFilters: 'Base list restrictions',
  BaseEntityVariables: 'Base list variables',
  BaseField: 'Base field',
  BasePrice: 'Base price',
  BaseTimeUnit: 'Base time unit',
  BaseUrl: 'Base URL',
  BaseUrlFrom: 'Base URL from',
  BaseUrlForActions: 'Base URL for open website actions',
  Billing: 'Billing',
  BillingAddress: 'Billing address',
  BlankValue: '(blank)',
  Board: 'Board',
  Body: 'Body',
  BodyForm: 'Body form',
  BodyType: 'Body type',
  BorderColor: 'Border color',
  Categories: 'Categories',
  Caching: 'Caching',
  CalculatedField: 'Calculated field',
  CalculatedFields: 'Calculated fields',
  CalculatedVariable: 'Calculated variable',
  CalculatedVariables: 'Calculated variables',
  Calculation: 'Calculation',
  Calculations: 'Calculations',
  Calendar: 'Calendar',
  Cancel: 'Cancel',
  CancelButton: 'Cancel button',
  CancelButtonLabel: 'Cancel button label',
  CancelSubscription: 'Cancel subscription',
  CantDelete: "Can't delete",
  CardEndingIn: 'Card ending in',
  CardFields: 'Card fields',
  CardTitle: 'Card title',
  Category: 'Category',
  CategoryField: 'Category field',
  Change: 'Change',
  ChangeAdmin: 'Change administrator',
  ChangeEndpoint: 'Change endpoint',
  ChangeOwner: 'Change owner',
  ChangeProfilePicture: 'Change profile picture',
  ChangePassword: 'Change password',
  ChangeSubscription: 'Change subscription',
  Chart: 'Chart',
  ChartExportFilename: 'chart.png',
  ChartType: 'Chart type',
  ChartSettings: 'Chart settings',
  Chat: 'Chat',
  CheckStatus: 'Check status',
  ChildFields: 'Child fields',
  Children: 'Children',
  ChunkField: 'Chunk field',
  ChunkStrategy: 'Chunk strategy',
  Certification: 'Certification',
  Certifications: 'Certifications',
  City: 'City',
  ClearAll: 'Clear all',
  ClearFilters: 'Clear all filters',
  ClearGroups: 'Clear all groups',
  ClickEditFilter: 'Click to edit filters',
  ClientId: 'Client ID',
  Close: 'Close',
  CloseMenu: 'Close menu',
  CloseWithoutSaving: 'Close without saving',
  Code: 'Code',
  CodeGenerator: 'Code generator',
  Collapse: 'Collapse',
  CollapseAll: 'Collapse all',
  CollapseCard: 'Collapse card',
  CollapseColumn: 'Collapse column',
  Color: 'Color',
  Colors: 'Colors',
  ColorCoding: 'Color coding',
  ColorGradients: 'Color gradients',
  Column: 'Column',
  ColumnField: 'Column field',
  ColumnNumber: 'Column {0}',
  Columns: 'Columns',
  ColumnToDuplicate: 'Column to duplicate',
  Companies: 'Companies',
  Company: 'Company',
  CompanyIdFieldPath: 'Company ID field path',
  CompanyPlaceholderId: '{0} ID',
  CompanyPlaceholderName: '{0} name',
  CompanyName: 'Company name',
  CompanyPluralPrompt: 'Company plural prompt',
  CompanyPrompt: 'Company prompt',
  CompanySettings: 'Company settings',
  Compare: 'Compare',
  CompareDependencies: 'Compare dependencies',
  CompareEntityPlaceholder: 'Compare {0}',
  CompareFields: 'Compare fields',
  CompareFromEntity: 'Compare from list',
  CompareFromEntityRestrictions: 'Compare from list restrictions',
  CompareToEntity: 'Compare to list',
  CompareToEntityRestrictions: 'Compare to list restrictions',
  CompareToConnector: 'Compare to connector',
  ComparisonMethodDifferences: 'Show differences',
  ComparisonMethodSimilarities: 'Show similarities',
  ComparisonType: 'Comparison type',
  ConfirmationPrompt: 'Confirmation prompt',
  ConfirmButton: 'Confirm button',
  ConfirmDelete: 'Confirm delete',
  Connect: 'Connect',
  ConnectAndSave: 'Connect and save',
  Connections: 'Connections',
  ConnectionType: 'Connection type',
  Connector: 'Connector',
  ConnectorAction: 'Connector action',
  ConnectorActionField: 'Connector action field',
  ConnectorActions: 'Field type actions',
  ConnectorLogo: 'Connector logo',
  ConnectorPermissions: 'Connector permissions',
  Connectors: 'Connectors',
  ConnectorSettings: 'Connector settings',
  ConnectorVariables: 'Connector variables',
  ContactDetails: 'Contact details',
  ConjunctiveAnd: 'and',
  ConjunctiveOr: 'or',
  Constant: 'Constant',
  ConstantValue: 'Constant value',
  Copy: 'Copy',
  CopyCalculatedFields: 'Copy calculated fields to the new list',
  CopyConnectors: 'Copy connectors',
  CopyListItems: 'Copy list items',
  CopyToClipboard: 'Copy to clipboard',
  CopyRoles: 'Copy roles',
  CopyRow: 'Copy row',
  CopySecurity: 'Copy security',
  CopyTeams: 'Copy teams',
  CopyUser: 'Copy from another user',
  CopyValue: 'Copy value',
  Country: 'Country',
  Course: 'Course',
  Courses: 'Courses',
  CreateWidget: 'Create widget',
  CreatedDate: 'Created date',
  CreateVisualforcePage: 'Create Visualforce page',
  CreditCard: 'Credit card',
  CreditCardExpired: 'Credit card expired',
  CropImage: 'Crop image',
  Csv: 'CSV',
  Currency: 'Currency',
  CurrentProcess: 'Current integration',
  Custom: 'Custom',
  CustomActions: 'Custom actions',
  CustomizationPermissions: 'Customization permissions',
  CustomDateFormat: 'Custom date format',
  CustomEntities: 'Custom lists',
  CustomResponses: 'Custom responses',
  Dashboard: 'Dashboard',
  Dashboards: 'Dashboards',
  Database: 'Database',
  DataEndpoints: 'Data endpoints',
  DataSource: 'Data source',
  DateSummaryMethod: 'Date summary method',
  DateLevels: 'Date levels',
  DateField: 'Date field',
  DateFormat: 'Date format',
  DateRange: 'Date range',
  DateValue: 'Date value',
  DateTime: 'Date/time',
  DateTimeOptions: 'Date/time options',
  DateTimeAdjustmentMethod: 'Date/time adjustment method',
  Days: 'Days',
  Deactivate: 'Deactivate',
  DeactivateUser: 'Deactivate user',
  DeactivateWidget: 'Unpublish widget',
  Descending: 'Descending',
  DecimalPlaces: 'Decimal places',
  Default: 'Default',
  DefaultColumns: 'Default columns',
  DefaultEntity: 'Default list',
  DefaultFields: 'Default fields',
  DefaultPath: 'Default path',
  DefaultScript: 'Default script',
  DefaultValue: 'Default value',
  DefaultValues: 'Default values',
  DefaultValueType: 'Default value type',
  DefaultView: 'Default view',
  Delete: 'Delete',
  DeletedConnectors: 'Deleted connectors',
  DeleteExtension: 'Delete extension',
  DeleteFavorite: 'Delete favorite',
  DeleteField: 'Delete field',
  DeleteProcess: 'Delete integration',
  DeleteVisualforcePage: 'Delete Visualforce page',
  Dependencies: 'Dependencies',
  Description: 'Description',
  Destination: 'Destination',
  Detail: 'Detail',
  DetailDisplayTypeBelow: 'Below the record',
  DetailDisplayTypeRight: 'In the sidebar',
  DetailDisplayTypeDrillDown: 'Drill down to a new page',
  DetailDisplayTypeNone: 'Do not display',
  Details: 'Details',
  DetailSettings: 'Detail settings',
  DetailTypeGroup: 'Group',
  DetailTypeList: 'List',
  DetailTypeSingleton: 'Single record',
  DetailTypeSummary: 'Summary',
  DetailTypeShipping: 'Shipping details',
  DetailTypeIFrame: 'IFrame',
  DetailTypeImage: 'Image',
  Developer: 'Developer',
  DeveloperPermissions: 'Developer permissions',
  Difficulty: 'Difficulty',
  Dimension: 'Dimension',
  Dimensions: 'Dimensions',
  DisableNotifications: 'Disable notifications',
  DisableSorting: 'Disable sorting',
  DisableFiltering: 'Disable filtering',
  DisableGrouping: 'Disable grouping',
  DisableTotals: 'Disable totals',
  Display: 'Display',
  DisplayAsNegative: 'Display as negative',
  DisplayAsNegativeBasedOnField: 'Display as negative based on another field',
  DisplayField: 'Display field',
  DisplayFields: 'Display fields',
  DisplayForAllCompanies: 'Display for all companies',
  DisplayMethod: 'Display method',
  DisplayTimeUnit: 'Display time unit',
  DisplayType: 'Display type',
  DisplayValuesInList: 'Display available values in a drop down list',
  DisplayValue: 'Display value',
  Domain: 'Domain',
  DoneEditing: 'Done editing',
  DoNotCopy: 'Do not copy',
  DoNotDefault: 'Do not default',
  DoNotDisplayWidget: 'Do not display this widget',
  DoNotImport: 'Do not import',
  Download: 'Download',
  DownloadFailed: 'Download failed',
  Downloads: 'Downloads',
  Duplicate: 'Duplicate',
  DuplicateAction: 'Duplicate action',
  DuplicateColumn: 'Duplicate column',
  DuplicateEntity: 'Duplicate list',
  DuplicateFields: 'Duplicate fields',
  DuplicateRole: 'Duplicate role',
  DuplicateRow: 'Duplicate row',
  DuplicateTeam: 'Duplicate team',
  Dynamic: 'Dynamic',
  EachUserNeedsCredentials:
    'Require each Popdock user to enter their own credentials for this connector',
  Edit: 'Edit',
  EditAction: 'Edit action',
  EditActionField: 'Edit action field',
  EditAllFields: 'Edit all fields',
  EditCalculatedColumn: 'Edit calculated column',
  EditCalculatedField: 'Edit calculated field',
  EditCalculatedRow: 'Edit calculated row',
  EditCalculation: 'Edit calculation',
  EditColumn: 'Edit column',
  EditConnector: 'Edit connector',
  EditConnectorAction: 'Edit connector action',
  EditConnectorSettings: 'Edit connector settings',
  EditCustomAction: 'Edit custom action',
  EditCustomEntity: 'Edit custom list',
  EditDashboard: 'Edit dashboard',
  EditDetail: 'Edit detail',
  EditDecimalPlaces: 'Edit decimal places',
  EditDynamicRow: 'Edit dynamic row',
  EditEmbeddedApp: 'Edit embedded app',
  EditEmbeddedApps: 'Edit embedded apps',
  EditEndpoint: 'Edit endpoint',
  EditEntity: 'Edit list',
  EditEntityAction: 'Edit list action',
  EditExportAction: 'Edit export action',
  EditFavorite: 'Edit favorite',
  EditField: 'Edit field',
  EditFields: 'Edit fields',
  EditFilter: 'Edit filter',
  EditFirewall: 'Edit firewall',
  EditFiscalYear: 'Edit fiscal year',
  EditWidgetFirewall: 'Edit widget firewall',
  EditFlow: 'Edit flow',
  EditGroup: 'Edit group',
  EditHomePage: 'Edit home page',
  EditHomePageItem: 'Edit home page item',
  EditJob: 'Edit job',
  EditJoin: 'Edit join',
  EditListItem: 'Edit list item',
  EditListItems: 'Edit list items',
  EditLookup: 'Edit lookup',
  EditMergeList: 'Edit merge list',
  EditOpenUrlAction: 'Edit open website action',
  EditParameter: 'Edit parameter',
  EditProfile: 'Edit profile',
  EditRelationship: 'Edit relationship',
  EditRestriction: 'Edit restriction',
  EditRole: 'Edit role',
  EditRow: 'Edit row',
  EditSendApiRequestAction: 'Edit send API request action',
  EditSettings: 'Edit settings',
  EditScript: 'Edit script',
  EditSidebar: 'Edit sidebar',
  EditSort: 'Edit sort',
  EditStyle: 'Edit style',
  EditSummaryColumn: 'Edit summary column',
  EditSummaryMethod: 'Edit summary method',
  EditSummaryRow: 'Edit summary row',
  EditTable: 'Edit table',
  EditTag: 'Edit tag',
  EditTeam: 'Edit team',
  EditTheme: 'Edit theme',
  EditWidget: 'Edit widget',
  EditUser: 'Edit user',
  EditVirtualNetwork: 'Edit virtual network',
  EditVariable: 'Edit variable',
  Email: 'Email',
  EmailAddress: 'Email address',
  EmailAddresses: 'Email addresses',
  EmbedCodes: 'Embed codes',
  Enabled: 'Enabled',
  EndDate: 'End date',
  EndIp: 'End IP',
  Endpoint: 'Endpoint',
  Endpoints: 'Endpoints',
  EndpointFrom: 'Endpoint from',
  EnterLinkName: 'Enter link name',
  EnterLinkUrl: '/path or https://example.com',
  EnterUrl: 'Enter URL',
  InputTopCount: 'Input top count',
  Instructions: 'Instructions',
  EnterConnectorName: 'Enter connector name',
  EnterNewTag: 'Enter new tag',
  EnterValue: 'Enter value',
  Entities: 'Lists',
  Entity: 'List',
  EntityObject: 'Entity',
  EntityAction: 'List action',
  EntityActions: 'List actions',
  EntityField: 'List field',
  EntityFields: 'List fields',
  EntityName: 'List name',
  EntitySettings: 'List settings',
  Environment: 'Environment',
  EnvironmentParameter: 'Environment parameter',
  EnvironmentParameters: 'Environment parameters',
  EnvironmentVersion: 'Environment version',
  Error: 'Error',
  ErrorCode: 'Error code',
  ErrorHandling: 'Error handling',
  Errors: 'Errors',
  Every: 'Every',
  EveryDay: 'Every day',
  Everyone: 'Everyone',
  Excel: 'Excel',
  ExcelAddin: 'Excel add-in',
  ExchangeToken: 'Exchange token',
  Expand: 'Expand',
  ExpandAll: 'Expand all',
  ExpandCard: 'Expand card',
  ExpandColumn: 'Expand column',
  Expires: 'Expires',
  ExpiresIn: 'Expires in',
  Export: 'Export',
  ExportActions: 'Export actions',
  ExportActionNames: 'Export action names',
  ExportConnector: 'Export connector',
  ExportEntityNames: 'Export list names',
  ExportFailed: 'Export failed',
  ExportFavorites: 'Export favorites',
  ExportFieldNames: 'Export field names',
  ExportFile: 'Export file',
  ExportFileType: 'Export type',
  ExportGroups: 'Export groups',
  ExportPermissions: 'Export permissions',
  ExportTo: 'Export to',
  ExportToMultipleFiles: 'Export to multiple files',
  Expression: 'Expression',
  Extender: 'Extender',
  Extension: 'Extension',
  ExtensionVersion: 'Extension version',
  Favorite: 'Favorite',
  FavoriteName: 'Favorite name',
  FavoriteOptions: 'Favorite options',
  Favorites: 'Favorites',
  FavoriteSummary: 'Favorite summary',
  Field: 'Field',
  FieldFromParentList: 'Field from parent list',
  FieldLanguage: 'Field language',
  FieldMapping: 'Field mapping',
  FieldMissing: '(Field missing)',
  FieldName: 'Field name',
  FieldPath: 'Field path',
  FieldToCopy: 'Field to copy',
  FieldType: 'Field type',
  Fields: 'Fields',
  FieldSettings: 'Field settings',
  FieldValue: 'Field value',
  File: 'File',
  FileFormat: 'File format',
  Filename: 'File name',
  FilePath: 'File path',
  Files: 'Files',
  FileSplits: 'File splits',
  Filter: 'Filter',
  Filters: 'Filters',
  FilterField: 'Filter field',
  FilterOnly: 'Filter only',
  FilterValue: 'Filter value',
  FilterVariable: 'Filter variable',
  FilterVariables: 'Filter variables',
  FindByConnector: 'Find by connector',
  FindByTag: 'Find by tag',
  FindInResults: 'Find in results',
  Finish: 'Finish',
  Finished: 'Finished',
  Firewall: 'Firewall',
  Firewalls: 'Firewalls',
  First: 'First',
  FirstDayOfWeek: 'First day of week',
  FirstName: 'First name',
  FirstResourceId: 'First resource ID',
  FiscalPeriod: 'Fiscal period',
  FiscalPeriods: 'Fiscal periods',
  FiscalYear: 'Fiscal year',
  FiscalYears: 'Fiscal years',
  Fix: 'Fix',
  FixUploadDatabase: 'Fix database upload',
  FixUploadTable: 'Fix table upload',
  Flow: 'Flow',
  FlowCredentials: 'Flow credentials',
  FlowField: 'Flow field',
  FlowParameter: 'Flow parameter',
  Flows: 'Flows',
  Folder: 'Folder',
  FollowLinkedIn: 'Follow us on LinkedIn',
  FollowTwitter: 'Follow us on Twitter',
  Font: 'Font',
  Form: 'Form',
  Format: 'Format',
  FormFields: 'Form fields',
  FormFieldType: 'Form field type',
  Forms: 'Forms',
  FormSettings: 'Form settings',
  Formula: 'Formula',
  Fourth: 'Fourth',
  FrequentlyUsed: 'Frequently used',
  FrequentlyUsedFavorites: 'Frequently used favorites',
  FromCompany: 'From company',
  FromEntity: 'From list',
  FromField: 'From field',
  FromResponseHeader: 'From response header',
  FromResponseBody: 'From response body',
  FromTable: 'From table',
  FromValue: 'From value',
  FromValueType: 'From value type',
  Function: 'Function',
  Generate: 'Generate',
  GenerateColumns: 'Generate columns',
  GenerateFiscalPeriods: 'Generate fiscal periods',
  GenerationMethod: 'Generation method',
  GetStarted: "Let's get started",
  GlobalVariable: 'Global variable',
  GlobalVariables: 'Global variables',
  GoBack: 'Go back',
  GoBackToAction: 'Go back to action',
  GoBackToAppStore: 'Go back to app store',
  GoBackToConnector: 'Go back to connector',
  GoBackToConnectors: 'Go back to connectors',
  GoBackToDeveloper: 'Go back to developer',
  GoBackToEntity: 'Go back to list',
  GoBackToSecurity: 'Go back to security',
  GoBackToWidget: 'Go back to widget',
  GoBackToUser: 'Go back to user',
  GoBackToTeam: 'Go back to team',
  GoBackToProfile: 'Go back to profile',
  Granularity: 'Granularity',
  GridColumnSizingMethod: 'Column sizing method',
  SelectGridColumnSizingMethod: 'Select a column sizing method',
  GridColumnSizingFitToGrid: 'Fit columns to the width of the grid',
  GridColumnSizingFixedColumn: 'Column width is based on the field type',
  Group: 'Group',
  GroupFields: 'Group fields',
  GroupNumber: 'Group number',
  Groups: 'Groups',
  HasMorePagesPath: 'Has more pages path',
  HasMorePagesPathType: 'Has more pages path type',
  Header: 'Header',
  HeaderField: 'Header field',
  HeaderLinkField: 'Header link field',
  Headers: 'Headers',
  Height: 'Height',
  Help: 'Help',
  HexColor: 'Hex color',
  Hidden: 'Hidden',
  HiddenField: 'Hidden field',
  HiddenFields: 'Hidden fields',
  Hide: 'Hide',
  HideColumns: 'Hide columns',
  HideDetails: 'Hide details',
  HideEmptyRows: 'Hide empty rows',
  HideFieldTypes: 'Hide field types',
  HideHelp: 'Hide help',
  HideSearch: 'Hide search',
  HideSettings: 'Hide settings',
  History: 'History',
  Home: 'Home',
  Hours: 'Hours',
  HtmlTable: 'HTML table',
  Icon: 'Icon',
  IFrame: 'IFrame',
  IFrameURL: 'IFrame URL',
  IFrameEmbedCode: 'IFrame embed code',
  Integrations: 'Integrations',
  IpAddresses: 'IP addresses',
  IPadApp: 'iPad app',
  IPhoneApp: 'iPhone app',
  Image: 'Image',
  ImageField: 'Image field',
  Images: 'Images',
  Import: 'Import',
  ImportConnector: 'Import connector',
  ImportFavorites: 'Import favorites',
  ImportFile: 'Import file',
  ImportFiscalYears: 'Import fiscal years',
  ImportByUser: 'Import by user',
  ImportByEntity: 'Import by list',
  ImportByFavorite: 'Import by favorite',
  ImportSmartListFavorites: 'Import SmartList favorites',
  Inactive: 'Inactive',
  Inactivate: 'Inactivate',
  InactiveUsers: 'Inactive users',
  IncludeDiagnostics: 'Include diagnostic information',
  IncludeEmptyRows: 'Include empty rows',
  InheritFromAccount: 'Inherit from account',
  InheritFromConnector: 'Inherit from connector',
  InputField: 'Input field',
  Insert: 'Insert',
  InsertField: 'Insert field',
  InsertFile: 'Insert file',
  InsertVariable: 'Insert variable',
  Insights: 'Insights',
  InsightTypeBar: 'Bar',
  InsightTypeBubble: 'Bubble',
  InsightTypeColumn: 'Column',
  InsightTypePie: 'Pie',
  InsightTypeDoughnut: 'Donut',
  InsightTypeArea: 'Area',
  InsightTypeLine: 'Line',
  InsightTypeFunnel: 'Funnel',
  InsightTypeNumber: 'Number',
  InsightTypeTreeMap: 'Tree map',
  Install: 'Install',
  Installing: 'Installing',
  InstallThisApp: 'Install this app',
  InvalidFile: 'Invalid file',
  InvalidPartnerCode: 'Invalid partner code',
  Invite: 'Invite',
  InvitedUsers: 'Invited users',
  InvitePartnerUser: 'Invite partner user',
  InvitePlaceholderUser: 'Invite {0} user',
  InviteSupportUsers: 'Invite support users',
  InviteUsers: 'Invite users',
  InvoiceNumber: 'Invoice number',
  InvoiceDate: 'Date',
  InvoiceAmount: 'Amount',
  InvoiceStatus: 'Status',
  Item: 'Item',
  Items: 'Items',
  ItemCountField: 'Item count path',
  ItemCountPathType: 'Item count path type',
  ItemField: 'Item field',
  ItemName: 'Item name',
  ItemSingular: 'Item singular',
  Jobs: 'Jobs',
  JobType: 'Job type',
  JoinFields: 'Join fields',
  JoinFromTable: 'Join from table',
  Joins: 'Joins',
  JoinType: 'Join type',
  Json: 'JSON',
  JsonPath: 'JSON path',
  JsonSchema: 'JSON schema',
  Key: 'Key',
  KeyFields: 'Key fields',
  Label: 'Label',
  Labels: 'Labels',
  LabelTemplate: 'Label template',
  Large: 'Large',
  LastDayOfMonth: 'Last day of the month',
  LastName: 'Last name',
  LastUpdateTime: 'Last update time',
  LastUsed: 'Last used',
  Later: "I'll do this later",
  Layout: 'Layout',
  Length: 'Length',
  Lessons: 'Lessons',
  LetsGetStarted: "Let's get started",
  LikeFacebook: 'Like us on Facebook',
  Link: 'Link',
  LinkedToConnector: 'Linked to connector',
  LinkedToEntity: 'Linked to list',
  Links: 'Links',
  LinkToEntity: 'Link to list',
  List: 'List',
  ListItems: 'List items',
  LoadListItems: 'Dynamically load list items from another list',
  Locale: 'Locale',
  Location: 'Location',
  LocationRecord: 'Record',
  Locked: 'Locked',
  LongDescription: 'Long description',
  Lookup: 'Lookup',
  Lookups: 'Lookups',
  MatchingFields: 'Matching fields',
  Mapping: 'Mapping',
  Markdown: 'Markdown',
  MaxCategories: 'Maximum number of categories',
  MaxRecords: 'Max records',
  MaxRetries: 'Maximum number of retries',
  Medium: 'Medium',
  Members: 'Members',
  MergeFields: 'Merge fields',
  Machine: 'Machine',
  Message: 'Message',
  Metadata: 'Metadata',
  Method: 'Method',
  Mfa: 'MFA',
  MfaEnabledFor: 'Enabled for',
  MfaOptionNotEnabled: 'Not enabled',
  MfaOptionAllUsers: 'Enabled for all users',
  MfaOptionAllAdmins: 'Enabled for all administrators',
  MfaOptionSelectedUsers: 'Enabled for selected users',
  MfaOptionSelectedTeams: 'Enabled for selected teams',
  MfaOptionSelectedRoles: 'Enabled for selected roles',
  MinimumPasswordLength: 'Minimum password length',
  Minutes: 'Minutes',
  ModifiedFavoriteIndicator: ' (modified)',
  MonthlyBill: 'Monthly bill',
  MonthlyCharges: 'Monthly charges',
  MonthName: 'Month name',
  MonthNumber: 'Month number',
  MoreInfo: 'More information',
  Move: 'Move',
  MoveDown: 'Move down',
  MoveToBottom: 'Move to bottom',
  MoveToColumnNumber: 'Move to column {0}',
  MoveToTop: 'Move to top',
  MoveUp: 'Move up',
  MoveRight: 'Move right',
  MoveLeft: 'Move left',
  MultiFactorAuth: 'Multi-factor authentication',
  MyApps: 'My apps',
  Name: 'Name',
  NameExists: 'This name already exists',
  NameFieldPath: 'Name field path',
  NameTemplate: 'Name template',
  NegativeField: 'Negative field',
  NegativeValues: 'Negative values',
  NetsuitePortlet: 'NetSuite portlet',
  Never: 'Never',
  NewColumnName: 'New column name',
  NewEntity: 'New list',
  NewPassword: 'New password',
  NewRowName: 'New row name',
  News: 'News',
  Next: 'Next',
  NextBillingDate: 'Next billing date',
  NextPageField: 'Next page link path',
  NextPageUrlPathType: 'Next page link path type',
  No: 'No',
  NoDefault: 'No default',
  None: 'None',
  NoneOfThese: "I don't use any of these",
  NoRecordsFound: 'No records found',
  NotConfigured: 'Not configured',
  Notes: 'Notes',
  Notifications: 'Notifications',
  NotSelected: 'Not selected',
  NotMapped: 'Not mapped',
  NumberOfFavorites: 'Number of favorites',
  NumberOfPeriods: 'Number of periods',
  OAuthSettings: 'OAuth settings',
  OAuthState: 'State',
  OData: 'OData',
  ODataVersion: 'OData version',
  OK: 'OK',
  OldPassword: 'Old password',
  OnlyDetails: 'Only display in details',
  OpenInNewTab: 'Open in new tab',
  OpenWebsite: 'Open website',
  OptionalParameters: 'Optional parameters',
  Options: 'Options',
  Optimization: 'Optimization',
  OthersChartCategory: 'Others',
  OutputField: 'Output field',
  Owner: 'Owner',
  OverwriteSecurity: 'Overwrite existing security settings',
  PageCountPath: 'Page count path',
  PageCountPathType: 'Page count path type',
  PageOffsetField: 'Page offset path',
  PageOffsetParameter: 'Page offset parameter',
  PageOffsetParameterType: 'Page offset parameter type',
  PageOffsetPathType: 'Page offset path type',
  PagingMethodItemCount: 'Item count',
  PageParameter: 'Page parameter',
  PageParameterType: 'Page parameter type',
  PageSize: 'Page size',
  PageSizeParameter: 'Page size parameter',
  PageSizeParameterType: 'Page size parameter type',
  Pages: 'Pages',
  Paging: 'Paging',
  PagingTokenExpiryAfterTime: 'After time period',
  PagingTokenExpiryOnError: 'On error',
  PagingTokenExpiryBeforeRequest: 'Before each request',
  PagingTokenExpiryTokenPath: 'After time period from token response',
  PagingTokenExpiryNever: 'Never',
  PagingMethod: 'Paging method',
  PagingMethodCustom: 'Custom',
  PagingMethodNone: 'None',
  PagingMethodNextPage: 'Next page number',
  PagingMethodNextLink: 'Next page link',
  PagingMethodPageCount: 'Page count',
  PagingMethodPageOffset: 'Page offset',
  PagingPaths: 'Paging paths',
  PagingParameters: 'Paging parameters',
  Parameter: 'Parameter',
  Parameters: 'Parameters',
  UrlParameters: 'URL parameters',
  ParameterType: 'Parameter type',
  Parent: 'Parent',
  ParentEntity: 'Parent list',
  ParentGroup: 'Parent group',
  PartnerUsers: 'Partner users',
  Password: 'Password',
  PasswordCannotContainRepeats: 'Password cannot contain repeated characters',
  PasswordCannotContainSequences: 'Password cannot contain sequences (eg 12345 or abcde)',
  PasswordExpires: 'Password expires',
  PasswordExpiryDays: 'Password expiry days',
  PasswordMustContainLowercase: 'Password must contain at least one lowercase character',
  PasswordMustContainNonAlpha: 'Password must contain at least one non-alphanumeric character',
  PasswordMustContainNumber: 'Password must contain at least one numeric character',
  PasswordMustContainUppercase: 'Password must contain at least one uppercase character',
  PasswordPolicy: 'Password policy',
  PasswordPreventReuse: 'Prevent password reuse',
  PasswordsToRemember: 'Number of passwords to remember',
  Path: 'Path',
  Pdf: 'PDF',
  PdfSettings: 'PDF settings',
  PendingConnectors: 'Pending connectors',
  PendingEntities: 'Pending lists',
  PeriodNumber: 'Period number',
  Permissions: 'Permissions',
  PhoneNumber: 'Phone number',
  PhoneNumberCleansing: 'Phone number cleansing',
  PivotTable: 'Pivot table',
  Placeholder: 'Placeholder',
  PlaceholderUsers: '{0} users',
  Points: 'Points',
  PostalCode: 'Postal code',
  PowerApps: 'Power apps',
  PreProcessing: 'Pre-processing',
  Preview: 'Preview',
  Previous: 'Previous',
  Process: 'Integration',
  Processes: 'Integrations',
  ProductAddress1: '1826 Kramer Lane',
  ProductAddress2: 'Suite e',
  ProductAddress3: 'Austin, TX 78758',
  ProductName: 'Popdock',
  Profile: 'Profile',
  ProfileType: 'Profile type',
  Prompt: 'Prompt',
  Publish: 'Publish',
  PublishSuccessful: 'Publish successful',
  Published: 'Published',
  Publisher: 'Publisher',
  PublishWidget: 'Publish widget',
  PublishedWidgets: 'Published widgets',
  Query: 'Query',
  QueryBuilder: 'Query builder',
  QueryEngine: 'Query engine',
  QueryEngineUrl: 'Query engine URL',
  QueryGenerator: 'Query generator',
  QueryOptimization: 'Query optimization',
  Reactivate: 'Reactivate',
  ReactivateUser: 'Reactivate user',
  ReadOnly: 'Read only',
  RecentlyUsed: 'Recently used',
  RecentlyUsedFavorites: 'Recently used favorites',
  Reconnect: 'Reconnect',
  Record: 'Record',
  Records: 'Records',
  Refresh: 'Refresh',
  RefreshAll: 'Refresh all',
  RefreshMethod: 'Refresh method',
  RefreshMethodNone: 'None',
  RefreshMethodOnError: 'On error',
  RefreshMethodAfterTimeExpires: 'After time period expires',
  RefreshMethodBeforeRequest: 'Before each request',
  RefreshMethodAfterRequest: 'After each request',
  RefreshToken: 'Refresh token',
  RefreshTokenLength: 'Length',
  RefreshTokenUnit: 'Unit',
  RefreshTokenUrl: 'Refresh token URL',
  RejectionDetails: 'Rejection details',
  Relationships: 'Relationships',
  RelativeDate: 'Relative date',
  Remove: 'Remove',
  RemoveAction: 'Remove action',
  RemoveBlanks: 'Remove blanks',
  RemoveConnector: 'Remove connector',
  RemoveEntity: 'Remove list',
  RemoveFilter: 'Remove filter',
  RemoveTab: 'Remove tab',
  RemoveTeam: 'Remove team',
  RemoveUser: 'Remove user',
  RemoveUserFromRole: 'Remove user from role',
  RemoveUserFromTeam: 'Remove user from team',
  RemoveWhenEmpty: 'Remove when empty',
  RemoveWhenEmptyValue: 'Remove parameter from query if value is empty',
  RemoveWidgetFromApp: 'Remove widget from app',
  Repair: 'Repair',
  Repeat: 'Repeat',
  Replace: 'Replace',
  ReplaceCreditCard: 'Replace credit card',
  ReplaceListItems: 'Replace existing list items',
  ReportingTrees: 'Reporting trees',
  ReportingTreeType: 'Reporting tree type',
  Request: 'Request',
  RequestMethod: 'Request method',
  RequestMethodInherit: 'Inherit from connector',
  RequestMethodGet: 'Get',
  RequestMethodPost: 'Post',
  RequestMethodPut: 'Put',
  RequestMethodPatch: 'Patch',
  RequestMethodDelete: 'Delete',
  Required: 'Required',
  RequiredParameters: 'Required parameters',
  RequiredPlaceholder: '{0} is required',
  Requirements: 'Requirements',
  RequireUserTokens: 'Require tokens for each user',
  ResendInvitation: 'Resend invitation email',
  Reset: 'Reset',
  ResetDefaults: 'Reset to default',
  ResetPassword: 'Reset password',
  Resources: 'Resources',
  Response: 'Response',
  ResponseCode: 'Response code',
  ResponseType: 'Response type',
  RestDateFormatCustom: 'Custom',
  RestDateFormatEpochMilliseconds: 'Epoch milliseconds',
  RestDateFormatEpochSeconds: 'Epoch seconds',
  RestDateFormatIso8601: 'ISO 8601',
  RestOptimizationNone: 'None',
  RestOptimizationOData: 'OData',
  RestOptimizationGraphQL: 'GraphQL',
  RestOptimizationEndpoint: 'Endpoint query mapping',
  Restore: 'Restore',
  Restriction: 'Restriction',
  Restrictions: 'Restrictions',
  RestrictionType: 'Restriction type',
  RestSettings: 'REST settings',
  ResubmitApp: 'Resubmit app',
  Retry: 'Retry',
  RetryErrorCodes: 'Retry error codes',
  RetryOnError: 'Retry on error',
  RetrySleepTime: 'Sleep time between retries (milliseconds)',
  RetryUpload: 'Retry upload',
  RetypePassword: 'Retype password',
  Reveal: 'Reveal',
  ReverseSign: 'Reverse sign',
  RevertFavorite: 'Revert to saved favorite',
  RightClickMenu: 'Right-click menu',
  Role: 'Role',
  Roles: 'Roles',
  RoleSettings: 'Role settings',
  RollingValue: 'Rolling value',
  Row: 'Row',
  Rows: 'Rows',
  RowToDuplicate: 'Row to duplicate',
  Rule: 'Rule',
  Rules: 'Rules',
  RunAction: 'Run action',
  RunJobAt: 'Run job at',
  RunNow: 'Run now',
  Runs: 'Runs',
  SalesforcePage: 'Visualforce page',
  Sandbox: 'Sandbox',
  SandboxConnector: 'Sandbox connector',
  Sandboxes: 'Sandboxes',
  Save: 'Save',
  SaveAsNewFavorite: 'Save as new favorite',
  SaveFavorite: 'Save favorite',
  SaveChanges: 'Save changes',
  SaveVisualforcePage: 'Save Visualforce page',
  Schedule: 'Schedule',
  ScheduleFavorite: 'Schedule favorite',
  Schema: 'Schema',
  Schedules: 'Schedules',
  Scope: 'Scope',
  Script: 'Script',
  Search: 'Search',
  SearchKnowledgeBase: 'Search knowledge base',
  Second: 'Second',
  Seconds: 'Seconds',
  Secret: 'Secret',
  Security: 'Security',
  SecurityPermissions: 'Security permissions',
  Select: 'Select',
  Selected: 'Selected',
  SelectAddressType: 'Select address type',
  SelectAll: 'Select all',
  SelectAccount: 'Select account',
  SelectAction: 'Select action',
  SelectActionType: 'Select action type',
  SelectApp: 'Select app',
  SelectApplication: 'Select application',
  SelectApplications: 'Select applications',
  SelectAvailability: 'Select availability',
  SelectBaseTimeUnit: 'Select base time unit',
  SelectBackgroundColor: 'Select background color',
  SelectBorderColor: 'Select border color',
  SelectCategory: 'Select category',
  SelectChartType: 'Select chart type',
  SelectChunkStrategy: 'Select chunk strategy',
  SelectColor: 'Select color',
  SelectColumns: 'Select columns',
  SelectCompany: 'Select company',
  SelectCompanyPlaceholder: 'Select {0}',
  SelectComparison: 'Select comparison',
  SelectComparisonField: 'Select comparison field',
  SelectComparisonType: 'Select comparison type',
  SelectConnector: 'Select connector',
  SelectConnectorCategory: 'Select connector category',
  SelectDatabase: 'Select database',
  SelectDatabases: 'Select databases',
  SelectDateValue: 'Select date value',
  SelectCurrency: 'Select currency',
  SelectDateFormat: 'Select date format',
  SelectDateGranularity: 'Select date granularity',
  SelectDayOfWeek: 'Select day of week',
  SelectDaysOfMonth: 'Select days of the month',
  SelectDaysOfWeek: 'Select days of the week',
  SelectDetail: 'Select detail',
  SelectDimension: 'Select dimension',
  SelectDisplayTimeUnit: 'Select display time unit',
  SelectDisplayType: 'Select display type',
  SelectEntities: 'Select lists',
  SelectEntity: 'Select list',
  SelectEnvironment: 'Select environment',
  SelectFavorite: 'Select favorite',
  SelectFavorites: 'Select favorites',
  SelectField: 'Select field',
  SelectFieldLanguage: 'Select field language',
  SelectFields: 'Select fields',
  SelectFieldType: 'Select field type',
  SelectFile: 'Select file',
  SelectFiscalPeriod: 'Select fiscal period',
  SelectFiscalYearOrPeriod: 'Select fiscal year or period',
  SelectFlow: 'Select flow',
  SelectFolder: 'Select folder',
  SelectForm: 'Select form',
  SelectFunction: 'Select function',
  SelectGenerationMethod: 'Select generation method',
  SelectGroup: 'Select group',
  SelectIcon: 'Select icon',
  SelectLocale: 'Select locale',
  SelectLocation: 'Select location',
  SelectMap: 'Select map',
  SelectIntegration: 'Select Integration',
  SelectMembers: 'Select members',
  SelectMethod: 'Select method',
  SelectNone: 'Select none',
  SelectParameter: 'Select parameter',
  SelectPath: 'Select path',
  SelectProcess: 'Select integration',
  SelectProfileType: 'Select profile type',
  SelectResourceType: 'Select resource type',
  SelectRestrictionType: 'Select restriction type',
  SelectResources: 'Select resources',
  SelectRoles: 'Select roles',
  SelectRows: 'Select rows',
  SelectSandbox: 'Select sandbox',
  SelectSortField: 'Select sort field',
  SelectSidebar: 'Select sidebar',
  SelectSummaryMethod: 'Select summary method',
  SelectTableSource: 'Select table source',
  SelectTable: 'Select table',
  SelectTables: 'Select tables',
  SelectTag: 'Select tag',
  SelectTeams: 'Select teams',
  SelectTeamMembers: 'Select team members',
  SelectTextColor: 'Select text color',
  SelectTextFormat: 'Select text format',
  SelectTheme: 'Select theme',
  SelectTimeZone: 'Select time zone',
  SelectType: 'Select type',
  SelectUser: 'Select user',
  SelectUsers: 'Select users',
  SelectValue: 'Select value',
  SelectValues: 'Select values',
  SelectVariable: 'Select variable',
  SelectVirtualNetwork: 'Select virtual network',
  SelectWidget: 'Select widget',
  Send: 'Send',
  SendEmail: 'Send email',
  SendUsAnEmail: 'Send us an email',
  SessionTimeout: 'Session timeout (minutes)',
  Settings: 'Settings',
  Setup: 'Setup',
  SetupComplete: 'Setup complete',
  SetValueFrom: 'Set value from',
  Service: 'Service',
  ShareFavorite: 'Share favorite',
  ShareWithTeams: 'Share with teams',
  ShareWithUsers: 'Share with users',
  Shipping: 'Shipping',
  Sharing: 'Sharing',
  ShortDescription: 'Short description',
  Show: 'Show',
  ShowCategoryLabels: 'Show category labels',
  ShowCode: 'Show code',
  ShowColumns: 'Show columns',
  ShowDetails: 'Show details',
  ShowFieldTypes: 'Show field types',
  ShowHeaders: 'Show headers',
  ShowHelp: 'Show help',
  ShowLegend: 'Show legend',
  ShowMenu: 'Show menu',
  ShowOthers: "Show 'Others' category",
  ShowPages: 'Show pages',
  ShowQueryEditor: 'Show query editor',
  ShowSearch: 'Show search',
  ShowSettings: 'Show settings',
  ShowValueLabels: 'Show value labels',
  ShowInheritedUserAccess: 'Show user access inherited from teams',
  Sidebar: 'Sidebar',
  SidebarId: 'Sidebar ID',
  Sidebars: 'Sidebars',
  SignOut: 'Sign out',
  SingleRecord: 'Single record',
  Size: 'Size',
  Skip: 'Skip',
  SkipBlankDates: 'Skip date fields when all values are blank',
  SkipBlankNumbers: 'Skip numeric fields when all values are zero',
  SkipBlankStrings: 'Skip string fields when all values are blank',
  SkipEmptyTables: "Don't upload empty tables",
  Slicers: 'Slicers',
  Small: 'Small',
  SmartConnect: 'SmartConnect',
  SortAscending: 'Sort ascending',
  SortBy: 'Sort by',
  SortByCategoryAsc: 'Category (ascending)',
  SortByCategoryDesc: 'Category (descending)',
  SortByValueAsc: 'Value (ascending)',
  SortByValueDesc: 'Value (descending)',
  SortByFrequentlyUsed: 'Sort by frequently used',
  SortByRecentlyUsed: 'Sort by recently used',
  SortByName: 'Sort by name',
  SortByConnector: 'Sort by connector',
  SortCardsBy: 'Sort cards by',
  SortDescending: 'Sort descending',
  SortDirection: 'Sort direction',
  Sorting: 'Sorting',
  SortingByFrequentlyUsed: 'Sorting by frequently used',
  SortingByRecentlyUsed: 'Sorting by recently used',
  SortingByName: 'Sorting by name',
  SortingByConnector: 'Sorting by connector',
  SortTabs: 'Sort tabs',
  Source: 'Source',
  SourceConnector: 'Source connector',
  SourceEntity: 'Source list',
  SplitOnField: 'Split on field',
  Spreadsheet: 'Spreadsheet',
  SqlTablesViews: 'SQL tables/views',
  Start: 'Start',
  StartDate: 'Start date',
  StartIp: 'Start IP',
  StartTime: 'Start time',
  StartUsing: 'Start using Popdock',
  State: 'State',
  Status: 'Status',
  StopSharing: 'Stop sharing',
  Style: 'Style',
  SubmitButtonLabel: 'Submit button label',
  Subscribe: 'Subscribe',
  SubscribeYouTube: 'Subscribe to our YouTube',
  Subscription: 'Subscription',
  SubscriptionDescription: '{0} ({1} per month)',
  Subfolder: 'Subfolder',
  Subject: 'Subject',
  Submit: 'Submit',
  SubmitApp: 'Submit app',
  SubmitApps: 'Submit your apps',
  SubmitNewApp: 'Submit a new app',
  Success: 'Success',
  SuggestApplication: 'Suggest application',
  SuggestNewConnector: 'Suggest new connector',
  Suggestion: 'Suggestion',
  Summary: 'Summary',
  SummaryColumnName: 'Summary column name',
  SummaryColumnMethod: 'Summary column method',
  SummaryColumns: 'Summary columns',
  SummaryEntity: 'Summary list',
  SummaryFields: 'Summary fields',
  SummaryMethod: 'Summary method',
  SummaryRows: 'Summary rows',
  SummaryTable: 'Summary table',
  SupportUsers: 'Support users',
  Switch: 'Switch',
  SwitchAccount: 'Switch account',
  SwaggerUrl: 'Swagger URL',
  SystemDatabase: 'System database',
  SystemUser: 'System',
  Tab: 'Tab',
  Tabs: 'Tabs',
  Table: 'Table',
  TableName: 'Table name',
  Tag: 'Tag',
  TaggedFavorites: 'Tagged favorites',
  Tags: 'Tags',
  TaskType: 'Task type',
  Tax: 'Tax',
  Team: 'Team',
  Teams: 'Teams',
  TeamSettings: 'Team settings',
  Test: 'Test',
  TestAction: 'Test action',
  TestApiEndpoint: 'Test API endpoint',
  Text: 'Text',
  TextColor: 'Text color',
  TextFormat: 'Text format',
  TextOptions: 'Text options',
  TextSearch: 'Text search',
  Theme: 'Theme',
  Third: 'Third',
  Time: 'Time',
  TimePeriodSeconds: 'Seconds',
  TimePeriodMinutes: 'Minutes',
  TimePeriodHours: 'Hours',
  TimePeriodDays: 'Days',
  TimeZone: 'Time zone',
  Title: 'Title',
  ToCompany: 'To company',
  ToEntity: 'To list',
  ToField: 'To field',
  Token: 'Token',
  TokenExpires: 'Token expires',
  TokenResponsePath: 'Token response path',
  TokenName: 'Token name',
  Tokens: 'Tokens',
  Toolbar: 'Toolbar',
  Tooltip: 'Tooltip',
  Total: 'Total',
  ToTable: 'To table',
  ToValue: 'To value',
  ToValueType: 'To value type',
  TrackingNumberField: 'Tracking number field',
  Transfer: 'Transfer',
  TransferOwnership: 'Transfer ownership',
  TrialExpired: 'Trial expired',
  Type: 'Type',
  Types: 'Types',
  TypePlaceholderField: '{0} field',
  Units: 'Units',
  Unpublish: 'Unpublish',
  UnpublishWidget: 'Unpublish widget',
  UnpublishedWidgets: 'Unpublished widgets',
  Unsubscribe: 'Unsubscribe',
  Unsubscribed: 'Unsubscribed',
  Update: 'Update',
  UpdateColorCodingRule: 'Update color coding rule',
  UpdateCreditCard: 'Update credit card',
  UpdateDependency: 'Update dependency',
  UpdateProcess: 'Update integration',
  Upload: 'Upload',
  UploadChunks: 'Upload in chunks',
  UploadDatabase: 'Upload whole databases',
  UploadEntity: 'Upload list',
  UploadHistory: 'Upload history',
  UploadTable: 'Upload a single table',
  UploadTables: 'Upload tables',
  UploadType: 'Upload type',
  Url: 'URL',
  UrlEncodedForm: 'URL encoded form',
  UrlParameter: 'URL parameter',
  Usage: 'Usage',
  UseCustomResponseNoData: 'Return a custom response when no data is returned',
  UseCustomDateFormat: 'Use a custom date format',
  UseHeadersFromParentAction: 'Use headers from parent action',
  UseParameterGroups: 'Use parameter groups',
  UseParametersFromParentAction: 'Use parameters from parent action',
  User: 'User',
  UseRefreshTokens: 'Use refresh tokens',
  UserInput: 'User input',
  UserInputTypeNone: 'None',
  UserInputTypeConfirmation: 'Confirmation',
  UserInputTypeText: 'Enter text',
  UserName: 'User name',
  Users: 'Users',
  UserSecurity: 'User security',
  UsersInvited: 'Users invited',
  UserVariable: 'User variable',
  UserVariables: 'User variables',
  Validate: 'Validate',
  ValidateConnection: 'Validate connection',
  ValidateConnector: 'Validate the connector before saving',
  ValidateExtension: 'Validate extension',
  ValidateDataSource: 'Validate the data source first',
  ValidateScript: 'Validate script',
  Value: 'Value',
  ValueField: 'Value field',
  ValueFields: 'Value fields',
  ValueFrom: 'Value from',
  ValueMapping: 'Value mapping',
  ValueType: 'Value type',
  Variable: 'Variable',
  Variables: 'Variables',
  Version: 'Version',
  VersionMajor: 'Major',
  VersionMinor: 'Minor',
  VersionRevision: 'Revision',
  VersionBuild: 'Build',
  Videos: 'Featured videos',
  View: 'View',
  ViewInvoice: 'View invoice',
  ViewType: 'View type',
  VirtualNetwork: 'Virtual network',
  VirtualNetworks: 'Virtual networks',
  Website: 'Website',
  Widget: 'Widget',
  WidgetId: 'Widget ID',
  Widgets: 'Widgets',
  WidgetOptionGroupDisplay: 'Display',
  WidgetOptionGroupFavorites: 'Favorites',
  WidgetOptionGroupFiltering: 'Filtering',
  WidgetOptionGroupFeatures: 'Features',
  WidgetOptionActions: 'Show actions',
  WidgetOptionAddFavorite: 'Add new favorites',
  WidgetOptionCollapse: 'Allow collapsing of widgets',
  WidgetOptionDefaultCollapse: 'Collapse widget',
  WidgetOptionColumns: 'Show columns',
  WidgetOptionDetails: 'Show details',
  WidgetOptionEditFavorite: 'Edit favorites',
  WidgetOptionExport: 'Allow export',
  WidgetOptionFavorite: 'Show favorites',
  WidgetOptionFilter: 'Show filter',
  WidgetOptionFilterDescription: 'Show filter description',
  WidgetOptionGroup: 'Allow grouping',
  WidgetOptionPages: 'Show pages',
  WidgetOptionRecordCount: 'Show record count',
  WidgetOptionRefresh: 'Allow refresh',
  WidgetOptionSearch: 'Show search',
  WidgetOptionSettings: 'Show settings',
  WidgetOptionSidebar: 'Display widget as sidebar',
  WidgetOptionTabLabel: 'Show tab labels',
  WidgetOptionTitle: 'Show title',
  WidgetOptionTotals: 'Show totals',
  WidgetOptionViewType: 'Change view type',
  WidgetOptionEagerLoad: 'Load data immediately',
  WidgetOptionDisplayEmptyFields: 'Show fields with no data',
  WidgetOptionShowCompanies: 'Show companies dropdown',
  WidgetOptionShowZoom: 'Show zoom',
  WidgetOptionRequireToken: 'Require token',
  WidgetOptionParameterHierarchy: 'Use alternative parameter groups when no data is found',
  WidgetTypeApplication: 'Multiple lists',
  WidgetTypeCards: 'Cards',
  WidgetTypeDashboard: 'Dashboard',
  WidgetTypeFavorite: 'Single list',
  WidgetTypeForm: 'Form',
  WidgetTypeImage: 'Image',
  WidgetTypeSearch: 'Search',
  WidgetTypeShipping: 'Shipping details',
  WidgetTypeSidebar: 'Widget group',
  WidgetTypeSingleton: 'Single record',
  WidgetTypeSummary: 'Summary',
  Width: 'Width',
  Xml: 'XML',
  Year: 'Year',
  Yes: 'Yes',
  ZoomOut: 'Zoom out',
  ZoomIn: 'Zoom in',

  // Modal titles — added for Labels-based title standardization
  AccountSaveError: 'Account save error',
  ActionSaveError: 'Action save error',
  AdditionalColumns: 'Additional columns',
  AddIpAddressError: 'Add IP address error',
  AddRoleError: 'Add role',
  ApiRoutesError: 'API routes error',
  ApiServiceFieldsError: 'API service fields error',
  AppRegistrationError: 'App registration create error',
  AppRegistrationSaveError: 'App registration error',
  AuditLogDetail: 'Audit log detail',
  BaseObjectsError: 'Base objects error',
  BoardListsError: 'Board lists list error',
  BoardsListError: 'Boards list error',
  CacheQueryModelError: 'Cache query model error',
  CallbackError: 'Callback error',
  CancelImport: 'Cancel import',
  CancelRunError: 'Cancel run error',
  ChangeTriggerMaintenanceSaveError: 'Change trigger maintenance save error',
  CheckAllTitle: 'Check all',
  CheckNameDateTimeFormatError: 'Check name date time format error',
  CheckNameGlobalVariableError: 'Check name global variable error',
  CheckNameIntegrationGroupError: 'Check name integration group error',
  CheckNameRestServiceError: 'Check name REST service error',
  CheckNameRollingColumnError: 'Check name rolling column error',
  CheckNameSourceError: 'Check name source error',
  CheckNameTranslationTableError: 'Check name translation table error',
  ChildEntityDetailsError: 'Child entity details error',
  ClearMfaSecretError: 'Clear MFA secret error',
  ClearMfaSecretConfirmation: 'Confirm clear MFA secret',
  ClearPermission: 'Clear permission',
  ClearTranslationLines: 'Clear translation lines',
  CollapseAllTitle: 'Collapse all',
  ColumnsError: 'Columns error',
  CompaniesError: 'Companies error',
  CompanyListError: 'Company list error',
  ConfirmAppRegistrationDelete: 'Confirm app registration delete',
  ConfirmConnectionReset: 'Confirm connection reset',
  ConfirmFilDelete: 'Confirm file delete',
  ConfirmFirewallDelete: 'Confirm firewall delete',
  ConfirmIpAddressDelete: 'Confirm IP address delete',
  ConfirmIsSecureChange: 'Confirm IsSecure change',
  ConfirmMoveTitle: 'Confirm move',
  ConfirmSaveTitle: 'Confirm save',
  ConfirmSyncUsers: 'Confirm sync users',
  ConfirmTeamDelete: 'Confirm team delete',
  ConfirmVirtualNetworkDelete: 'Confirm virtual network delete',
  Confirmation: 'Confirmation',
  ConnectionCreateError: 'Connection create error',
  ConnectionDeleteError: 'Connection delete error',
  ConnectionsError: 'Connections error',
  CreateError: 'Create error',
  CreateUserError: 'Create user error',
  CurrentProcessRunsError: 'Current integration runs error',
  CustomRecordsError: 'Custom records error',
  DatabaseLoadError: 'Database load error',
  DatabaseTableColumnsError: 'Database table columns error',
  DatabaseTablesError: 'Database tables error',
  DatabasesError: 'Databases error',
  DataSourceCreateError: 'Data source create error',
  DataSourceDeleteError: 'Data source delete error',
  DateFormatCreateError: 'Date format create error',
  DateFormatDeleteError: 'Date format delete error',
  DateFormatUpdateError: 'Date format update error',
  DateFormatsFetchError: 'Date formats fetch error',
  DeleteConfirmation: 'Delete confirmation',
  DeleteConnection: 'Delete connection',
  DeleteError: 'Delete error',
  DeleteIpAddressError: 'Delete IP address error',
  DeleteLine: 'Delete line',
  DeleteNodeTitle: 'Delete node',
  DeleteProcessRun: 'Delete integration run',
  DeleteProcessTitle: 'Delete integration',
  DeleteRole: 'Delete role',
  DeleteValidationError: 'Delete validation error',
  DeselectNode: 'Deselect node',
  DestinationLineLoadError: 'Destination line load error',
  DisableTitle: 'Disable',
  DownloadError: 'Download error',
  DraftModifiedByAnotherUser: 'Draft modified by another user',
  DuplicateFound: 'Duplicate found',
  DuplicateProcess: 'Duplicate integration',
  EditQueryFail: 'Edit query fail',
  EditTitle: 'Edit',
  EnableTitle: 'Enable',
  EntitiesError: 'Entities error',
  EntityColumnsError: 'Entity columns error',
  EntityLoadError: 'Entity load error',
  EntitySaveError: 'Entity save error',
  ErrorGettingConnectionDetails: 'Error getting connection details',
  ExcelWorksheetsError: 'Excel worksheets error',
  ExportFailure: 'Export failure',
  ExportIntegration: 'Export integration',
  ExportServiceError: 'Export service error',
  ExpandAllTitle: 'Expand all',
  ExtenderIDsError: 'Extender IDs error',
  ExternalSettingsError: 'External settings error',
  FailedToGetDirectories: 'Failed to get directories',
  FavouritesListError: 'Favourites list error',
  FetchError: 'Fetch error',
  FileDeleteError: 'File delete error',
  FileLoadError: 'File load error',
  FileReadError: 'File read error',
  FirewallLoadError: 'Firewall load error',
  FormattingError: 'Formatting error',
  GlobalVariableDeleteError: 'Global variable delete error',
  GlobalVariableError: 'Global variable error',
  GlobalVariablesError: 'Global variables error',
  GlobalVariablesFetchError: 'Global variables fetch error',
  GraphConnectionsError: 'Graph connections error',
  GroupListError: 'Group list error',
  GroupsListError: 'Groups list error',
  HelpEmailSendError: 'Help email send error',
  HistoryProcessRunsError: 'Integration run history error',
  ImportFailure: 'Import failure',
  ImportSuccess: 'Import success',
  IntegrationGroupDeleteError: 'Integration group delete error',
  IntegrationGroupUpdateError: 'Integration group update error',
  IntegrationGroupsFetchError: 'Integration groups fetch error',
  IntegrationIdChanged: 'Integration ID changed',
  InvalidTemplate: 'Invalid template',
  InvalidateTemplate: 'Invalidate template',
  LinkedMapsError: 'Linked maps error',
  LinkedServicesError: 'Linked services error',
  LookupSaveError: 'Lookup save error',
  MaintenanceFetchError: 'Maintenance fetch error',
  NoData: 'No data',
  OrganizationsError: 'Organizations error',
  OverwriteConfirmation: 'Overwrite confirmation',
  ParseFileFailure: 'Parse file(s) failure',
  ParsingJsonError: 'Parsing JSON error',
  PasswordChangeError: 'Password change error',
  PopdockListError: 'Popdock list error',
  ProcessCloneError: 'Integration clone error',
  ProcessDeleteError: 'Integration delete error',
  ProcessDetailCountError: 'Integration detail count error',
  ProcessDetailError: 'Integration detail error',
  ProcessErrorsListError: 'Integration errors list error',
  ProcessLocked: 'Integration locked',
  ProcessOutputsError: 'Integration outputs error',
  ProcessReRun: 'Integration re-run',
  ProcessRunConfirmation: 'Integration run confirmation',
  ProcedureLoadError: 'Procedure load error',
  ProfileSaveError: 'Profile save error',
  QueryBuilderError: 'Query builder error',
  RealtimeRequestDownloadError: 'Realtime request download error',
  RealtimeStagingLogError: 'Realtime staging log error',
  RedirectDeleteConfirmation: 'Redirect delete confirmation',
  RedirectDeleteError: 'Redirect delete error',
  RefreshConfirmation: 'Refresh confirmation',
  RefreshError: 'Refresh error',
  RefreshServiceListError: 'Refresh service list error',
  RegistrationConfirmation: 'Registration confirmation',
  RegistrationError: 'Registration error',
  RegistrationSuccess: 'Registration success',
  RerunProcess: 'Rerun integration',
  ResetNotAllowed: 'Reset not allowed',
  ResetPasswordError: 'Reset password error',
  ResetPasswordTitle: 'Reset password',
  RestMetadataFailure: 'REST metadata failure',
  RestServiceCreateError: 'REST service create error',
  RestServiceDeleteError: 'REST services delete error',
  RestServicesFetchError: 'REST services fetch error',
  RoleCategoriesError: 'Role categories error',
  RollingColumnDeleteError: 'Rolling columns delete error',
  RollingColumnsFetchError: 'Rolling columns fetch error',
  RollingColumnUpdateError: 'Rolling column update error',
  RoleTypesError: 'Role types error',
  RouteListError: 'Route list error',
  RunFailure: 'Run failure',
  RunNowConfirmation: 'Run now',
  SalesforceObjectsError: 'Salesforce objects error',
  SaveAuditSettingsError: 'Save audit settings error',
  SaveConfirmation: 'Save confirmation',
  SaveFailure: 'Save failure',
  SaveFirewallError: 'Save firewall error',
  SavePasswordPolicyError: 'Save password policy error',
  SaveRestDefinitionError: 'Save REST definition error',
  SaveTeamError: 'Save team error',
  SavedSearchError: 'Saved search error',
  SchedulerCreateError: 'Scheduler create error',
  SchedulerDeleteError: 'Scheduler delete error',
  SchemaReadError: 'Schema read error',
  SearchRecordTypesError: 'Search record types error',
  SecretDeleteConfirmation: 'Secret delete confirmation',
  SecurityError: 'Security error',
  ServiceColumnsError: 'Service columns error',
  ServiceFieldsError: 'Service fields error',
  ServiceListError: 'Service list error',
  ServicesError: 'Services error',
  SoapRefreshFailure: 'SOAP refresh failure',
  SyncUsersError: 'Sync users error',
  SystemSettingsError: 'System settings error',
  SystemSettingsSaveError: 'System settings save error',
  TableFieldError: 'Table field error',
  TableLoadError: 'Table load error',
  TablesError: 'Tables error',
  TeamConnectionCreateError: 'Team connection create error',
  TeamCreateError: 'Team create error',
  TeamMemberCreateError: 'Team member create error',
  TeamRoleCreateError: 'Team role create error',
  TeamSaveError: 'Team save error',
  TeamsChannelListError: 'Teams channel list error',
  TeamsListError: 'Teams list error',
  TranslationTableCreateError: 'Translation tables create error',
  TranslationTableDeleteError: 'Translation tables delete error',
  TranslationTablesFetchError: 'Translation tables fetch error',
  UnableToImportFile: 'Unable to import the file',
  UncheckAllTitle: 'Uncheck all',
  UpdateError: 'Update error',
  UpdateUserError: 'Update user error',
  UploadFailed: 'Upload failed',
  UploadSuccessful: 'Upload successful',
  UserError: 'User error',
  ValidateSuccess: 'Validate success',
  Validated: 'Validated',
  ValidationError: 'Validation error',
  ValidationFail: 'Validation fail',
  ValidationSuccess: 'Validation success',
  ViewAuditLogs: 'View audit logs',
  ViewDetail: 'View detail',
  WebServiceDeleteLogError: 'Web service delete log error',
  WebServiceDownloadError: 'Web service download error',
  WebServiceLogError: 'Web service log error',
  WebhookSaveError: 'Webhook save error',
  ActionNotes: 'Action notes',
  AddAppRegistration: 'Add app registration',
  AddChangeTriggerMaintenance: 'Add change trigger maintenance',
  AddConnectorVariable: 'Add connector variable',
  AddDataSource: 'Add data source',
  AddDateTimeFormat: 'Add date time format',
  AddIntegrationGroup: 'Add integration group',
  AddProcessToDataSource: 'Add integration to data source',
  AddRedirectUri: 'Add redirect URI',
  AddRestService: 'Add REST service',
  AddScheduler: 'Add scheduler',
  AddSchemaColumn: 'Add schema column',
  AddSchemaRow: 'Add schema row',
  AddSecret: 'Add secret',
  AddSourceCalculation: 'Add source calculation',
  AddTranslationTable: 'Add translation table',
  ApiDetails: 'API details',
  ApplicationRegistrations: 'Application registrations',
  ApplicationRegistrationSecrets: 'Application registration secrets',
  AppRegistration: 'App registration',
  AppRegistrationRedirects: 'App registration redirects',
  AppRegistrationSecrets: 'App registration secrets',
  Audit: 'Audit',
  AuditLogs: 'Audit logs',
  AuditLogsDetail: 'Audit logs detail',
  AuditSettings: 'Audit settings',
  BaseFields: 'Base fields',
  BlankValues: 'Blank values',
  CachedItems: 'Cached items',
  CallbackEvents: 'Callback events',
  CallbackParameters: 'Callback parameters',
  CallbackResponse: 'Callback response',
  ChangeDatasourceOptions: 'Change datasource options',
  ChangeTriggerMaintenance: 'Change trigger maintenance',
  ChildEntities: 'Child entities',
  CloneRestService: 'Clone REST service',
  ColumnHeadersEditFormat: 'Column headers edit format',
  CurrentProcessRuns: 'Current integration runs',
  CurrentUsage: 'Current usage',
  DataSourceFields: 'Data source fields',
  DataSourceOptions: 'Data source options',
  DataSources: 'Data sources',
  DateTimeFormats: 'Date time formats',
  DateTimeSettings: 'Date time settings',
  DefaultHeaders: 'Default headers',
  DefaultParameters: 'Default parameters',
  Drafts: 'Drafts',
  EditChildEntity: 'Edit child entity',
  EditSchema: 'Edit schema',
  EntityHeaders: 'Entity headers',
  EntityNotes: 'Entity notes',
  FilterService: 'Filter service',
  HistoryProcessRuns: 'Integration run history',
  ImportProcessErrors: 'Import integration errors',
  ImportTranslationTable: 'Import translation table',
  IntegrationGroups: 'Integration groups',
  IntegrationProcessOutputs: 'Integration outputs',
  JsonFile: 'JSON file',
  JsonFileEditFormat: 'JSON file edit format',
  KeyFile: 'Key file',
  LinkedIntegrationRegistration: 'Linked integration registration',
  LinkedIntegrations: 'Linked integrations',
  LinkedService: 'Linked service',
  LinkServices: 'Link services',
  LoadFieldsFromJsonOrFile: 'Load fields from JSON or file',
  LoggingOptions: 'Logging options',
  LookupCriteria: 'Lookup criteria',
  LookupDefinitions: 'Lookup definitions',
  LookupFilterCriteria: 'Lookup filter criteria',
  Manual: 'Manual',
  MultiFactorAuthentication: 'Multi-factor authentication',
  Namespaces: 'Namespaces',
  NoDataErrorCodes: 'No data error codes',
  OAuthRedirects: 'OAuth redirects',
  OutgoingMailSettings: 'Outgoing mail settings',
  ParentFields: 'Parent fields',
  Procedures: 'Procedures',
  ProcessRun: 'Integration run',
  ProcessRunsDetail: 'Integration runs detail',
  ProcessTemplates: 'Integration templates',
  Realtime: 'Realtime',
  RealtimeCallbackStaging: 'Realtime callback staging',
  RealtimeRequestLogs: 'Realtime request logs',
  RegisterRequired: 'Register required',
  Registration: 'Registration',
  RelatedJoins: 'Related joins (select appropriate join and columns for saved search)',
  RestApplicationRegistrations: 'REST application registrations',
  RestrictColumns: 'Restrict columns',
  RestServices: 'REST services',
  RestTemplates: 'REST templates',
  RetryStatusCodes: 'Retry status codes',
  ReturnableFields: 'Returnable fields',
  RollingColumns: 'Rolling columns',
  RunProcess: 'Run integration',
  RunSmartConnectProcess: 'Run SmartConnect integration',
  RuntimeVariables: 'Runtime variables',
  ScheduleRuns: 'Schedule runs',
  Scripting: 'Scripting',
  SelectPlaceholder: 'Select placeholder',
  SelectTeamRoles: 'Select team roles',
  SerializedRequest: 'Serialized request',
  Services: 'Services',
  SmartConnectDocumentation: 'SmartConnect documentation',
  SourceDefinitions: 'Source definitions',
  SourceFile: 'Source template file',
  SourceLookupErrorCodes: 'Source / lookup error codes',
  SourceSchema: 'Source schema',
  SuiteQlSchema: 'SuiteQL schema',
  SystemDateTimeFormats: 'System date time formats',
  TableRestrictions: 'Table restrictions',
  Tables: 'Tables',
  TargetDefinitions: 'Target definitions',
  TargetErrorCodes: 'Target error codes',
  TargetLines: 'Target lines',
  TemplateFile: 'Template File',
  TransformFile: 'Transform template file',
  Translations: 'Translations',
  TranslationTable: 'Translation table',
  TranslationTables: 'Translation tables',
  UnmappedFields: 'Unmapped fields',
  UpdateTriggerColumns: 'Update trigger columns',
  UploadedFiles: 'Uploaded files',
  UsedPlaceholders: 'Used placeholders',
  WebhookDefinitions: 'Webhook definitions',
  WebhookSettings: 'Webhook settings',
  XmlFile: 'XML file',
  XmlFileEditFormat: 'XML file edit format',
  XmlFileFormatEdit: 'XML file format edit',
};

const FieldTypes = {
  Currency: 'Currency',
  Date: 'Date',
  Email: 'Email',
  Image: 'Image',
  Integer: 'Number',
  Percentage: 'Percentage',
  Phone: 'Phone',
  Quantity: 'Quantity',
  Skype: 'Skype',
  String: 'String',
  Text: 'Text',
  Time: 'Time',
  Twitter: 'Twitter',
  Url: 'Website',
  YesNo: 'Yes/no',
  Enum: 'Drop-down list',
  Color: 'Color',
  Address: 'Address',
  Guid: 'GUID',
  Icon: 'Icon',
  TimeSpan: 'Time span',
  Profile: 'Profile',
  Dimension: 'Dimension',
  File: 'File',
  None: 'None',
  Timespan: 'TimeSpan',
};

const ChartTypes = {
  Column: 'Column',
  Bar: 'Bar',
  Pie: 'Pie',
  Doughnut: 'Donut',
  Area: 'Area',
  Line: 'Line',
  Funnel: 'Funnel',
  Number: 'Number',
  Bubble: 'Bubble',
  TreeMap: 'Tree map',
};

const Months = {
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
};

const ShortMonths = {
  January: 'Jan',
  February: 'Feb',
  March: 'Mar',
  April: 'Apr',
  May: 'May',
  June: 'Jun',
  July: 'Jul',
  August: 'Aug',
  September: 'Sep',
  October: 'Oct',
  November: 'Nov',
  December: 'Dec',
};

const DaysOfWeek = {
  Sunday: 'Sunday',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
};

const Messages = {
  AccountCancelled: 'Your Popdock subscription was cancelled',
  AccountCancelledContactAdmin:
    'Your Popdock subscription was cancelled, please contact your account administrator to resubscribe.',
  AddAnotherColorCodingRule: 'Add another rule',
  AddAnotherGroupField: 'Add another group field',
  AddAnotherJoin: 'Add another join',
  AddAnotherFilter: 'Add another filter',
  AddConnectorDetails: 'Add connector details',
  AddCustomDetail: 'Add custom detail',
  AddingColumns: 'Adding columns...',
  AddingConnector: 'Adding connector...',
  AddingEntities: 'Adding lists...',
  AddingFields: 'Adding fields...',
  AddingTables: 'Adding tables...',
  AllColorsAdded: 'All colors have been added',
  AllColumnsAdded: 'All columns have been added',
  AllCompaniesAdded: 'All {0} have been added',
  AllEntitiesAdded: 'You have already added all lists',
  AllFieldsAddedToEntity: 'All fields have been added to the list',
  AllFieldsAddedForEntity: 'All fields have been added for this list',
  AllFieldsAddedToWidget: 'All fields have been added to the widget',
  AllFiscalYearsAdded: 'All fiscal years have been added',
  AllGood: "It's all good",
  AllResourcesPublished: 'All resources were published successfully',
  AlreadyPopdockUsers: '{0} users were already Popdock users.',
  BlankKey: 'Key cannot be blank',
  BlankName: 'Name cannot be blank',
  BlankPrompt: 'Prompt cannot be blank',
  BlankValue: 'Value cannot be blank',
  CategoryNotSelected: 'A category has not been selected',
  ChangingSubscription: 'Changing subscription...',
  CheckingForErrors: 'Checking for errors...',
  ClearingFilters: 'Clearing filters...',
  ClickAddAction: 'Click here to add an action',
  ClickAddActions: 'Click here to add actions',
  ClickAddApiUser: 'Click here to add an API user',
  ClickAddApp: 'Click here to add a new app',
  ClickAddCalculatedField: 'Click here to add a calculated field',
  ClickAddCalculation: 'Click here to add a calculation',
  ClickAddCalculatedVariable: 'Click here to add a calculated variable',
  ClickAddColor: 'Click here to add a color',
  ClickAddColorCodingRule: 'Click here to add a color coding rule',
  ClickAddRule: 'Click here to add a rule',
  ClickAddCompany: 'Click here to add a {0}',
  ClickAddConnector: 'Click here to add a connector',
  ClickAddConnectorDetails: 'Click here to add connector details',
  ClickAddCustomDetail: 'Click here to add a custom detail',
  ClickAddCreditCard: 'Click here to add a credit card',
  ClickAddConnectorVariable: 'Click here to add a connector variable',
  ClickAddCustomEntityCompare: 'Click here to add a custom list that compares 2 lists',
  ClickAddCustomEntityJoin: 'Click here to add a custom list that joins multiple lists',
  ClickAddCustomEntityMerge: 'Click here to add a custom list that merges multiple lists',
  ClickAddCustomEntityRestriction: 'Click here to add a custom list that restricts data in a list',
  ClickAddCustomEntitySummary: 'Click here to add a custom list that summarizes data in a list',
  ClickAddCustomEntityMatrix: 'Click here to add a matrix list',
  ClickAddDashboard: 'Click here to add a dashboard',
  ClickAddDefaultField: 'Click here to add default fields',
  ClickAddDefaultsToFields: 'Click here to add existing default fields',
  ClickAddDefaultColumn: 'Click here to add default columns',
  ClickAddDependency: 'Click here to add a dependency',
  ClickAddDetail: 'Click here to add a detail',
  ClickAddDomainRestriction: 'Click here to add a domain restriction',
  ClickAddEndpoint: 'Click here to add an endpoint',
  ClickAddEntity: 'Click here to add a list',
  ClickAddEntityQueryBuilder: 'Click here to add a new list with the query builder',
  ClickAddEntities: 'Click here to add lists',
  ClickAddFavorite: 'Click here to add a favorite',
  ClickAddField: 'Click here to add a field',
  ClickAddFields: 'Click here to add fields',
  ClickAddFieldSample: 'Click here to add fields from a sample query or file',
  ClickAddFileSplit: 'Click here to add a file split',
  ClickAddFilter: 'Click here to add a filter',
  ClickAddFilterVariable: 'Click here to add a filter variable',
  ClickAddFiscalPeriod: 'Click here to add a single fiscal period',
  ClickAddFiscalPeriodRange: 'Click here to generate a range of fiscal periods',
  ClickAddFiscalYear: 'Click here to add a fiscal year',
  ClickAddFlow: 'Click here to add a flow',
  ClickAddGlobalVariable: 'Click here to add a global variable',
  ClickAddGroup: 'Click here to add a group',
  ClickAddGroupField: 'Click here to add a group field',
  ClickAddHeader: 'Click here to add a header',
  ClickAddInsight: 'Click here to add an insight',
  ClickAddIpAddress: 'Click here to add an IP address',
  ClickAddItem: 'Click here to add a new item',
  ClickAddItemToForm: 'Click here to add an item to the form',
  ClickAddJob: 'Click here to add a scheduled job',
  ClickAddJoin: 'Click here to add a join',
  ClickAddKeyField: 'Click here to add a key field',
  ClickAddListItem: 'Click here to add a list item',
  ClickAddLookup: 'Click here to add a lookup',
  ClickAddMultipleListItems: 'Click here to add multiple list items',
  ClickAddMatchingFields: 'Click here to add matching fields',
  ClickAddOptimization: 'Click here to add an optimization',
  ClickAddParameter: 'Click here to add a parameter',
  ClickAddPartnerUser: 'Click here to grant access to a partner user',
  ClickAddPlaceholderUser: 'Click here to grant access to a {0} user',
  ClickAddRelationship: 'Click here to add a relationship',
  ClickAddReportingTree: 'Click here to add a reporting tree',
  ClickAddResource: 'Click here to add a resource',
  ClickAddRestriction: 'Click here to add a restriction',
  ClickAddRetryStatusCodes: 'Click here to add a retry status code',
  ClickAddRole: 'Click here to add a role',
  ClickAddPage: 'Click here to add a page',
  ClickAddSandbox: 'Click here to add a sandbox',
  ClickAddSidebar: 'Click here to add a sidebar',
  ClickAddSort: 'Click here to add a sort',
  ClickAddSummaryFields: 'Click here to add summary fields',
  ClickAddSupportUser: 'Click here to temporarily grant access to a support user',
  ClickAddTab: 'Click here to add a tab',
  ClickAddTable: 'Click here to add a table',
  ClickAddTag: 'Click here to add a tag',
  ClickAddTeam: 'Click here to add a team',
  ClickAddToken: 'Click here to add a token',
  ClickAddUser: 'Click here to add a user',
  ClickAddUserVariable: 'Click here to add a user variable',
  ClickAddVirtualNetwork: 'Click here to add a virtual network',
  ClickAddWidget: 'Click here to add a widget',
  ClickAssignUser: 'Click here to assign a user',
  ClickCopyListItems: 'Click here to copy list items from another field',
  ClickCustomizeHomePage:
    'Click here to customize your home page with favorites, summaries and quick links',
  ClickEditFilter: 'Click to edit filter settings.',
  ClickEditScript: 'Click here to edit the script',
  ClickImportFiscalYears: 'Click here to import fiscal years from a connector',
  ClickResubscribe: 'Click here to resubscribe',
  ClickSelectRoles: 'Click here to select roles',
  ClickSelectTeams: 'Click here to select teams',
  ClickShareFavoriteTeam: 'Click here to share this favorite with a team',
  ClickShareFavoriteUser: 'Click here to share this favorite with an user',
  ClickSort: 'Click to sort by this column',
  ClickSortAscending: 'Click to sort in ascending order',
  ClickSortDescending: 'Click to sort in descending order',
  ClickSubscribe: 'Click here to subscribe',
  ClickUpdateSubscription: 'Click here to update your subscription',
  ConfirmReuploadEntity: 'Are you sure you want to re-upload this list?',
  ConfirmDeactivateUser: 'Are you sure you want to deactivate this user?',
  ConfirmDeactivateWidget: 'Are you sure you want to unpublish this widget?',
  ConfirmDeleteAction: 'Are you sure you want to delete this action?',
  ConfirmDeleteApp: 'Are you sure you want to delete this app?',
  ConfirmDeleteColor: 'Are you sure you want to delete this color?',
  ConfirmDeleteColorCoding: 'Are you sure you want to delete this color coding rule?',
  ConfirmDeleteColorGradient: 'Are you sure you want to delete this color gradient?',
  ConfirmDeleteColumn: 'Are you sure you want to delete this column?',
  ConfirmDeleteColumnAndFields:
    "Are you sure you want to remove this column and all of it's fields?",
  ConfirmDeleteCompany: 'Are you sure you want to delete this {0}?',
  ConfirmDeleteConnector: 'Are you sure you want to delete this connector?',
  ConfirmDeleteDashboard: 'Are you sure you want to delete this dashboard?',
  ConfirmDeleteDefaultField: 'Are you sure you want to remove this field from the default view?',
  ConfirmDeleteDependency: 'Are you sure you want to remove this dependency?',
  ConfirmDeleteDetail: 'Are you sure you want to delete this detail?',
  ConfirmDeleteDomain: 'Are you sure you want to delete this domain?',
  ConfirmDeleteEndpoint: 'Are you sure you want to delete this endpoint?',
  ConfirmDeleteEntity: 'Are you sure you want to delete this list?',
  ConfirmDeleteFastTab: 'Are you sure you want to delete this Fast Tab extension?',
  ConfirmDeleteFavorite: 'Are you sure you want to delete this favorite?',
  ConfirmDeleteField: 'Are you sure you want to delete this field?',
  ConfirmDeleteFileSplit: 'Are you sure you want to delete this file split?',
  ConfirmDeleteFile: 'Are you sure you want to delete this file?',
  ConfirmDeleteFilter: 'Are you sure you want to delete this filter?',
  ConfirmDeleteFilterVariable: 'Are you sure you want to delete this filter variable?',
  ConfirmDeleteFiscalPeriod: 'Are you sure you want to delete this fiscal period?',
  ConfirmDeleteFiscalYear: 'Are you sure you want to delete this fiscal year?',
  ConfirmDeleteForm: 'Are you sure you want to delete this form?',
  ConfirmDeleteFlow: 'Are you sure you want to delete this flow?',
  ConfirmDeleteGlobal: 'Are you sure you want to delete this global variable?',
  ConfirmDeleteGroup: 'Are you sure you want to delete this group?',
  ConfirmDeleteHeader: 'Are you sure you want to delete this header?',
  ConfirmDeleteHubspotCard: 'Are you sure you want to delete this HubSpot card?',
  ConfirmDeleteIpAddress: 'Are you sure you want to delete this IP address?',
  ConfirmDeleteImage: 'Are you sure you want to delete this image?',
  ConfirmDeleteItem: 'Are you sure you want to delete this item?',
  ConfirmDeleteJob: 'Are you sure you want to delete this job?',
  ConfirmDeleteKeyField: 'Are you sure you want to delete this key field?',
  ConfirmDeleteListItem: 'Are you sure you want to delete this list item?',
  ConfirmDeleteLookup: 'Are you sure you want to delete this lookup?',
  ConfirmDeleteMatchingFields: 'Are you sure you want to delete these matching fields?',
  ConfirmDeleteOptimization: 'Are you sure you want to delete this optimization?',
  ConfirmDeletePage: 'Are you sure you want to delete this page?',
  ConfirmDeleteParameter: 'Are you sure you want to delete this parameter?',
  ConfirmDeleteRelationship: 'Are you sure you want to delete this relationship?',
  ConfirmDeleteResource: 'Are you sure you want to delete this resource?',
  ConfirmDeleteRestriction: 'Are you sure you want to delete this restriction?',
  ConfirmDeleteRole: 'Are you sure you want to delete this role?',
  ConfirmDeleteRow: 'Are you sure you want to delete this row?',
  ConfirmDeleteSandbox: 'Are you sure you want to delete this sandbox?',
  ConfirmDeleteSidebar: 'Are you sure you want to delete this sidebar?',
  ConfirmDeleteSort: 'Are you sure you want to delete this sort?',
  ConfirmDeleteTab: 'Are you sure you want to delete this tab?',
  ConfirmDeleteTable: 'Are you sure you want to delete this table?',
  ConfirmDeleteTag: 'Are you sure you want to delete this tag?',
  ConfirmDeleteTeam: 'Are you sure you want to delete this team?',
  ConfirmRemoveTeam: 'Are you sure you want to remove this team?',
  ConfirmDeleteTextFormat: 'Are you sure you want to remove this text format?',
  ConfirmDeleteToken: 'Are you sure you want to delete this token?',
  ConfirmDeleteUser: 'Are you sure you want to delete this user?',
  ConfirmDeleteVirtualNetwork: 'Are you sure you want to delete this virtual network?',
  ConfirmRemoveUser: 'Are you sure you want to remove this user?',
  ConfirmDeleteWidget: 'Are you sure you want to delete this widget?',
  ConfirmDeleteVariable: 'Are you sure you want to delete this variable?',
  ConfirmDeleteVisualforcePage: 'Are you sure you want to delete this Visualforce page?',
  ConfirmPublishExtensionProduction:
    'Are you sure you want to publish this extension to your production environment?',
  ConfirmPublishWidget: 'Are you sure you want to publish this widget?',
  ConfirmRemoveAction: 'Are you sure you want to remove this action?',
  ConfirmRemoveConnector: 'Are you sure you want to remove this connector?',
  ConfirmRemoveEntity: 'Are you sure you want to remove this list?',
  ConfirmRemoveItem: 'Are you sure you want to remove this item?',
  ConfirmRemoveUserFromRole: 'Are you sure you want to remove this user from this role?',
  ConfirmRemoveUserFromTeam: 'Are you sure you want to remove this user from this team?',
  ConfirmRemoveWidgetFromApp: 'Are you sure you want to remove this widget from this app?',
  ConfirmStopSharingFavorite: 'Are you sure you want to stop sharing this favorite?',
  ConfirmUnsubscribe: 'Are you sure you want to unsubscribe from Popdock?',
  ConfirmUpdateDependencyVersion:
    'Are you sure that you want to change this dependency from {0} to version {1} to match your environment?',
  Connecting: 'Connecting...',
  ConnectorLoginFailed: 'Login failed or was cancelled',
  ConnectorSetupFailed: 'Connector setup failed',
  ConnectorUpToDate: 'This connector is up to date',
  CreditCardFailed: 'Your credit card has expired or was rejected',
  CreditCardFailedContactAdmin:
    'The credit card linked to your account failed, please contact your account administrator to update your subscription.',
  CustomActionInvalidSubscription:
    'Custom actions are only available for Business subscriptions and above',
  CustomEntityInvalidSubscription:
    'Custom lists are only available for Business subscriptions and above',
  DebugMode: 'Run in debug mode',
  DefaultScriptUsedForEntity: 'The default script is being used for this list',
  DetailNoFields: 'There are no fields for this detail',
  DetailNotSelected: 'A detail has not been selected',
  Downloading: 'Downloading...',
  DownloadFailed: 'Failed to download',
  DuplicatingAction: 'Duplicating action...',
  DuplicatingEntity: 'Duplicating list...',
  EnterPartnerCode: 'If you have a partner code, please enter it here',
  EnterPromoCode: 'If you have a promo code, please enter it here',
  EntityHidden: 'List is hidden from end users',
  EntityRemoved: 'This list has been removed',
  EntityPublishedSuccessfully: 'Your list was successfully published',
  EmailSent:
    'Your email has been sent. We will review your issue and get back to you as soon as possible.',
  ErrorLoadingFields: 'There was an error while loading fields',
  ErrorRunningAction: 'An error occurred while running the action',
  ErrorUnsubscribing: 'An error occurred while trying to unsubscribe. Please try again later.',
  Exporting: 'Exporting...',
  ExtensionPublishedSuccessfully: 'Your extension was published successfully',
  ExtensionMustBePublishedToSandbox:
    'You must create an extension using a sandbox connector before you can publish',
  FavoriteSearchPlaceholder: 'Enter the name of a favorite or list',
  FavoriteNotSharedWithTeams: 'This favorite is not shared with any teams',
  FavoriteNotSharedWithUsers: 'This favorite is not shared with any users',
  FavoriteNotUsedWidget: 'This favorite is not used on any widgets',
  FavoriteNotUsedRecently: 'This favorite has not been recently used by any users',
  FieldsNotSortedForDetail: 'Fields are not sorted for this detail',
  FileNotValid: 'This file is not valid',
  FileUpload: 'Drag or drop your file here to upload',
  FileUploadDragDrop: 'Drag and drop your file here',
  FileUploadExcel: 'Drag or drop your excel source file here to upload',
  FileUploadExcelImport: 'Drag and drop your excel file here to upload',
  FileUploadExcelTemplate: 'Drag or drop your excel template file here to upload',
  FileUploadJson: 'Drag or drop your json file here to upload',
  FileUploadJsonTemplate: 'Drag or drop your json template file here to upload',
  FileUploadText: 'Drag or drop your text file here to upload',
  FileUploadXmlTemplate: 'Drag or drop your xml template file here to upload',
  FileUploadXmlTransform: 'Drag or drop your transform file here to upload',
  FileUploadFtp:
    'Drag or drop your value file here to upload - Only OpenSSH and ssh.com formats supported',
  FilenameAlreadyUsedByEntity: 'This filename is already in use by another list',
  Filtering: 'Filtering...',
  Finished: 'Finished',
  GeneratingColumns: 'Generating columns...',
  GeneratingFile: 'Generating file...',
  GettingDashboards: 'Getting dashboards...',
  GettingRoles: 'Getting roles...',
  GettingTeams: 'Getting teams...',
  GettingTeamMembers: 'Getting team members...',
  GettingWidgets: 'Getting widgets...',
  GettingUsers: 'Getting users...',
  GoodToGo: 'You are all good to go!',
  Importing: 'Importing...',
  ImportingFavorites: 'Importing favorites...',
  ImportFiscalYears: 'Import fiscal years from a connector',
  InvalidIpAddress: 'IP address must be a valid IPv4 address',
  InvalidJsonError: 'JSON must be an object or array',
  InvalidValue: 'This value is invalid',
  InstallingConnectors: 'Please wait while we install your connectors',
  InvalidPartnerCode: 'The partner code entered was not valid.',
  IssuesFoundComparingEntities:
    'Issues were found when comparing the following lists to your production environment:',
  Loading: 'Loading...',
  LoadingColors: 'Loading colors...',
  LoadingEntities: 'Loading lists...',
  LoadingFavorite: 'Loading favorite...',
  LoadingFields: 'Loading fields...',
  LoadingFiscalYears: 'Loading fiscal years...',
  LoadingTables: 'Loading tables...',
  LoadingUsers: 'Loading users...',
  LoadingUpload: 'Uploading...',
  LoginInstructions:
    'You have selected the following applications. You will need to log in to these applications to authorize Popdock to access them.',
  MajorVersionsDontMatch: "Major versions don't match",
  MaximumRecords: 'Maximum records reached.',
  MaximumTokens: 'Maximum number of tokens has been assigned',
  MinorVersionsDontMatch: "Minor versions don't match",
  MissingFieldPlaceholder: 'Missing field: {0}',
  MissingExtension: 'Extension with matching name and publisher not found',
  MissingRequiredFields: 'Not all required fields are entered',
  MissingTablePlaceholder: 'Missing table: {0}',
  MfaAuthenticatorAppRequired: 'You must have at least one authenticator app selected',
  NameExists: 'This name already exits',
  NoAccessActionsUser: 'This user does not have any access to any actions',
  NoAccessActionsTeam: 'This team does not have any access to any actions',
  NoAccessEntitiesUser: 'This user does not have any access to any lists',
  NoAccessEntitiesTeam: 'This team does not have any access to any lists',
  NoAccessConnectorsUser: 'This user does not have any access to any connectors',
  NoAccessConnectorsTeam: 'This team does not have any access to any connectors',
  NoAccessCompaniesUser: 'This user does not have any access to any companies',
  NoAccessCompaniesTeam: 'This team does not have any access to any companies',
  NoActions: 'There are no actions',
  NoActionsAdded: 'You have not added any actions',
  NoActionsForConnector: 'There are no actions for this connector',
  NoActionsForEntity: 'You have not added any actions to this list',
  NoActiveConnectors: 'There are no active connectors',
  NoApiUsageRecords: 'You have no API usage records',
  NoAppRegistrations: 'You have not added any app registrations',
  NoApps: 'You have not added any apps',
  NoAuditInformation: 'There is no audit information linked to this connection',
  NoBaseEntity: 'You have not selected a base list',
  NoCacheItems: 'No items currently in cache',
  NoCallbackParameters: 'You have not added any callback parameters',
  NoCalculatedFields: 'There are no calculated fields for this list',
  NoCalculatedFieldsAdded: 'You have not added any calculated fields',
  NoCalculatedVariables: 'You have not added any calculated variables',
  NoCalculatedFieldsForExport: 'You have not selected any calculated fields to export',
  NoAddedCalculations: 'You have not added any calculations',
  NoChangeTriggerMaintenance: 'You have not defined change trigger maintenance',
  NoCalculations: 'There are no calculations for this connector',
  NoCurrentProcessRuns: 'No current integration runs found',
  NoCreditCard: 'You do not have a credit card saved',
  NoColors: 'You do not have any colors',
  NoColorsSelected: 'You have not selected any colors',
  NoColorCodingRules: 'You have not added any color coding rules',
  NoRules: 'You have not added any rules',
  NoColumnFilters: 'This column does not have any filters',
  NoColumnsAdded: 'You have not added any columns',
  NoColumnsSelected: 'No columns have been selected',
  NoCompaniesSelected: 'No {0} have been selected',
  NoConnectors: 'You have not added any connectors',
  NoConnectorToExport: 'You have not selected a connector to export',
  NoOptionsToExport: 'You have not selected any resources to export',
  NoConnectorsToUpload: 'You do not have any connectors installed that can be uploaded',
  NoConnectorVariables: 'You have not added any connector variables',
  NoCustomEntities: 'You have not added any custom lists for this connector',
  NoDatasources: 'There are no data sources linked to this connection',
  NoDashboards: 'You have not added any dashboards',
  NoDataToPreview: 'No data to preview',
  NoDateFormats: 'You have no date time formats',
  NoDefaultHeaders: 'You have not added any default headers',
  NoDefaultParameters: 'You have not added any default parameters',
  NoDefaultFields: 'There are no default fields for this list',
  NoDefaultColumns: 'There are no default columns for this list',
  NoDraftsConnection: 'No drafts use this connection',
  NoDraftsDatasource: 'No drafts use this data source',
  NoDependencies: 'You have not added any dependencies',
  NoDetails: 'There are no details for this list',
  NoDetailsForConnector: 'There are no details for this connector',
  NoDimensionsLoaded: 'No dimensions were loaded',
  NoDomainRestrictions: 'You have not restricted the widget to any domains',
  NoFirewalls: 'You have not added any firewalls',
  NoFavoritesForEntity: 'There are no favorites for this list',
  NoFavoritesForTag: 'This tag does not have any favorites',
  NoFavoritesForTeam: 'There are no favorites for this team',
  NoFavoritesForUser: 'There are no favorites for this user',
  NoFilenameEntered: 'You have not entered a filename',
  NoExcelUsageRecords: 'You have no Excel usage records',
  NoEndpoints: 'You do not have any endpoints',
  NoEndpointsAdded: 'You have not added any endpoints',
  NoEntities: 'You have not added any lists',
  NoEntitiesForConnector: 'There are no lists for this connector',
  NoEntitiesForAddFields: 'You have not added any lists. You must add a list before adding fields.',
  NoEntitiesQueryBuilder: 'You have not added any lists with the query builder',
  NoEntitiesForWidget: 'There are no lists for this widget',
  NoEntitiesSelected: 'You have not selected any lists',
  NoEntitiesToAdd: 'There are no lists to be added',
  NoErrors: 'No errors found',
  NoErrorCodes: 'You have not added any retry error codes',
  NoFavoritesForConnector: 'There are no favorites for this connector',
  NoFavoritesForExport: 'You have not selected any favorites to export',
  NoFavoritesSelected: 'You have not selected any favorites',
  NoFields: 'You have not added any fields',
  NoFieldsForEntity: 'There are no fields for this list',
  NoFieldsForLookup: 'There are no fields for this lookup',
  NoFieldsSelected: 'You have not selected any fields',
  NoWidgetFields:
    'You have not selected any fields. This widget will display the default fields for the list.',
  NoFileSplits: 'You have not added any file splits for this list',
  NoFilters: 'You have not added any filters',
  NoFilterVariables: 'You have not added any filter variables',
  NoFiscalPeriods: 'You have not added any fiscal periods',
  NoFiscalYears: 'You have not added any fiscal years',
  NoFiscalYearsSelected: 'You have not selected any fiscal years',
  NoFiscalYearsForConnector: 'This connector does not have any fiscal years',
  NoFlows: 'You have not added any flows',
  NoFormFieldsAdded: 'You have not added any form fields',
  NoFormFieldsForAction: 'There are no form fields for this action',
  NoGlobalVariables: 'There are no global variables',
  NoGlobalVariablesAdded: 'You have not added any global variables',
  NoGroupFields: 'You have not added any group fields',
  NoGroups: 'There are no groups for this connector',
  NoGroupsForWidget: 'There are no groups for this widget',
  NoHistoryProcessRuns: 'No integration run history records found',
  NoHeaders: 'There are no headers',
  NoHeadersForAction: 'There are no headers for this action',
  NoHeadersForConnector: 'There are no headers for this connector',
  NoHeadersForEntity: 'There are no headers for this list',
  NoIncompleteConnectors: 'No incomplete connectors',
  NoIncompleteDatasources: 'No incomplete data sources',
  NoIntegrationGroups: 'You have no integration groups',
  NoHiddenFieldsAdded: 'You have not added any hidden fields',
  NoHiddenFieldsForAction: 'There are no hidden fields for this action',
  NoHomePageContent: 'You have not added any content to your home page',
  NoItems: 'There are no items',
  NoItemsForColumn: 'There are no items in this column',
  NoItemsForForm: 'There are no items for this form',
  NoInsights: 'You have not added any insights',
  NoInvoices: 'You do not have any invoices',
  NoIpAddressesForFirewall: 'You have not added any IP addresses to this firewall',
  NoIpAddressesForVirtualNetwork: 'You have not added any IP addresses to this virtual network',
  NoLinkedMaps: 'You do not have any linked maps',
  NoLinkedProcesses: 'No linked integrations',
  NoJobs: 'You have not added any scheduled jobs',
  NoJoins: 'You have not added any joins',
  NoKeyFieldsForEntity: 'There are no key fields for this list',
  NoManualUsageRecords: 'You have no Manual usage records',
  NoMembers: 'You have not added any members',
  NoMatchingFields: 'You have not added any matching fields',
  NoRealtimeUsageRecords: 'You have no Realtime usage records',
  NoRealtimeRequestLogs: 'You have no Realtime request logs',
  NoRecentRunActivities: 'No recent run activities',
  NoRedirectUris: 'You have not added any redirect uris',
  NoReportingTrees: 'You have not added any reporting trees',
  NoRestServices: 'You have no rest services',
  NoRestTemplates: 'No REST templates have been added',
  NoReturnableFields: 'You have not created any returnable fields',
  NoResources: 'You have not added any resources',
  NoResourcesToExport: 'You have not selected any resources to export',
  NoRestrictions: 'You have not added any restrictions',
  NoRestrictionsForField: 'There are no restrictions for this field',
  NoRestrictionsListMissing:
    'You have not added any restrictions. You have to select a list before you can add restrictions.',
  NoRelationships: 'There are no relationships for this list',
  NoRollingColumns: 'You have no rolling columns',
  NoRoles: 'You have not added any roles',
  NoRows: 'You have not added any rows',
  NoRowFilters: 'This row does not have any filters',
  NoListItems: 'There are no list items for this list',
  NoLookups: 'You have not added any lookups',
  NoLookupsList: 'There are no lookups for this list',
  NoNotes: 'You have not added any notes',
  NoOptimizationsForEntity: 'There are no optimizations for this list',
  NoOptionsSelected: 'You have not selected any options',
  NoOptionalParameters: 'There are no optional parameters',
  NoOwnedFavoritesForUser: 'This user does not own any favorites',
  NoSharedFavoritesForUser: 'This user does have any favorites shared with them',
  NoProcessesConnection: 'No integrations use this connection',
  NoProcessesDatasource: 'No integrations use this data source',
  NoProcessOutputs: 'You have no Integration Outputs',
  NoProcessRunRecords: 'No integration run records found',
  NoProcessTemplates: 'No integration templates have been added',
  NoPagesForDashboard: 'You have not added any pages to this dashboard',
  NoParameters: 'There are no parameters',
  NoParametersAdded: 'You have not added any parameters',
  NoParametersForAction: 'There are no parameters for this action',
  NoParametersForConnector: 'There are no parameters for this connector',
  NoParametersForDetail: 'There are no parameters for this detail',
  NoParametersForEndpoint: 'There are no parameters for this endpoint',
  NoParametersForEntity: 'There are no parameters for this list',
  NoParametersForSidebar: 'There are no parameters for this sidebar',
  NoPartnerUsers: 'You have not granted access to any partner users',
  NoPlaceholderUsers: 'You have not granted access to any {0} users',
  NoSandboxes: 'You have not added any sandboxes',
  NoSidebars: 'You have not added any sidebars',
  NoScheduleUsageRecords: 'You have no Schedule usage records',
  NoSchedules: 'You have not added any schedules',
  NoSchemaHelper: 'No Schema Helper',
  NoSecrets: 'You have not added any secrets',
  NoServicesAdded: 'You have not added any services',
  NoServicesConfigured: 'No services configured',
  NoSelectedFields: 'You have not selected any fields',
  NoSummaryFields: 'You have not added any summary fields',
  NoSupportUsers: 'You have granted access to any support users',
  NoTabs: 'You have not added any tabs',
  NoTabsForSidebar: 'You have not added any tabs to the sidebar',
  NoTablesToAdd: 'There are no tables to be added',
  NoTablesForQuery: 'You have not selected any tables for the query',
  NoTags: 'You have not added any tags',
  NoTargetDefinitions: 'You have not created any target definitions',
  NoSourceDefinitions: 'You have not created any source definitions',
  NoTeams: 'You have not added any teams',
  NoTeamsForConnector: 'There are no teams with access to this connector',
  NoTranslationTables: 'You have no translation tables',
  NoTokens: 'You have not added any tokens',
  NoTokensForUser: 'This user does not have any tokens',
  NoWidgetParameters: 'There are no parameters for this widget',
  NoWidgetEnvironmentParameters: 'You have not added any environment parameters',
  NoWidgets: 'You do not have any widgets',
  NoWidgetsAdded: 'You have not added any widgets',
  NoWidgetsToAdd: 'There are no widgets to add',
  NoWidgetsPage: 'You have not added any widgets to this page',
  NoWidgetSelected: 'You have not selected a widget',
  NoWidgetsSidebar: 'You have not added any widgets to this sidebar',
  NoUpcomingSchedules: 'No upcoming schedules',
  NoUsersInvited: 'No users were invited.',
  NoUsersSecurity: 'There are no users to set security for',
  NoApiUsersSecurity: 'You have not added any API users',
  NoUsers: 'You have not added any users',
  NoUsersForConnector: 'There are no users with access to this connector',
  NoAdditionalColumns: 'You have not added any additional columns',
  NoVariables: 'You have not added any variables',
  NoVariablesInRestSetup: 'You have not added any variables in your rest setup',
  NoWebhookDefinitions: 'You have not created any webhook definitions',
  NoWebhookFields: 'You have not created any fields',
  NoGroupsAdded: 'You have not created any groups',
  NoXmlNamespaces: 'You have no XML Namespaces defined',
  NoUserVariables: 'You have not added any user variables',
  NoVirtualNetworks: 'You have not added any virtual networks',
  NoVirtualNetworksForFirewall: 'You have not added any virtual networks for this firewall',
  NumberUsersInvited: '{0} users were invited.',
  NumberInvalidEmails: '{0} email addresses were invalid.',
  OpenAuthenticatorApp:
    'Open the authenticator app on your mobile device to view your authentication code',
  PageRequiredForDashboardWidgets: 'You need to add a page before you can add widgets',
  PremiumFeature: 'This feature is only available for Popdock Premium subscriptions',
  Processing: 'Processing...',
  Publishing: 'Publishing...',
  PublishingExtensionInvalidSubscription:
    'Publishing extensions is only available for Business subscriptions and above',
  QueryBuilderInvalidSubscription:
    'Query builder is only available for Business subscriptions and above',
  Recalculating: 'Recalculating...',
  RecordsNotFound: 'Records not found',
  RecordNotSelected: 'A record has not been selected',
  Refreshing: 'Refreshing...',
  RefreshingCompanies: 'Refreshing companies...',
  ReplaceParametersFromConnector: 'Replace parameters from connector',
  ReplaceHeadersFromConnector: 'Replace headers from connector',
  RequiredField: 'This field is required',
  RequiredFieldsNotEntered: 'Not all required fields have been entered',
  RequiredVariableNeedsDefault: 'Required variables must have a default value',
  RoleHasNoUsers: 'This role has no users assigned',
  RoleNameExists: 'This role name already exists',
  Saving: 'Saving...',
  SaveHomePageChanges: 'Save changes and go back to your home page.',
  SchedulingJob: 'Scheduling job...',
  SelectConnectorBeforeFavorites: 'You must select a connector before adding favorites',
  SelectEntityForFields: 'Select a list from the dropdown above to edit the fields for the list',
  SelectEntityForRelationships:
    'Select a list from the dropdown above to edit the relationships for the list',
  SelectFavoriteBeforeParameters:
    'A favorite has not been selected. You must select a favorite before you can add parameters.',
  SelectFormBeforeParameters:
    'A form has not been selected. You must select a form before you can add parameters.',
  SelectParametersForWidgetPreview:
    'Select the parameters to pass to the widget, then click here to display the preview',
  SelectShippingServices: 'Select the shipping services that you use:',
  SelectTables: 'Select tables and views',
  SelectUsersForFavoriteImport: 'Select the users you want to import favorites for',
  SomethingWentWrong: 'Something went wrong',
  StartDateGreaterThanEndDate: 'The start date is greater than end date',
  StartDateEqualsEndDate: 'The start date and end date are the same',
  StartingProcess: 'Starting integration...',
  StartUsing:
    'Now that you know everything (at least the Popdock-related everything), you can now start using Popdock to get all the data you need',
  TagExists: 'This tag already exists',
  TablePlaceholder: 'Table: {0}',
  TeamNameExists: 'This team name already exists',
  Time24Hour: 'All times must be entered in 24 hour format',
  TrialExpired: 'Your Popdock trial has expired',
  TrialExpiredContactAdmin:
    'Your Popdock trial has expired, please contact your account administrator to subscribe.',
  UserHasNoRoles: 'This user is not a member of any roles',
  UserHasNoTeams: 'This user is not a member of any teams',
  Unsubscribed: 'You are now unsubscribed',
  UseSampleSettings: 'Use the sample settings to test this connector',
  Validating: 'Validating...',
  ValidatingConnection: 'Validating connection...',
  ValidatingDatabase: 'Validating database connection...',
  WaitingForUserInput: 'Waiting for user input',
  Welcome: 'Welcome to Popdock',
  WelcomeStart:
    'Before you can use Popdock, we need to know some information about the applications that you use.',
  WelcomeEnd: 'Popdock is now set up and ready to go. ',
  WhatApplicationTypes: 'What types of applications do you use?',
  WidgetPublishedSuccessfully: 'Your widget has been successfully published',
  WhereToFindConnectorSetupInfo: 'Where do I find the information I need?',
  WrongCredentials: 'Username/password were not correct',
};

const Explanations = {
  Account: {
    FiscalPeriods: '',
    GlobalVariables: '',
  },
  CompareEntity: {
    MatchingFields: '',
    CompareFromRestrictions: '',
    CompareToRestrictions: '',
  },
  Dashboards: {
    Dashboards: '',
  },
  Developer: {
    ApiEndpoints: 'Create custom API endpoints that returns the data for any favorite',
    Apps: 'Apps are collections of widgets. Creating an app lets you group and edit related widgets in one place.',
    Jobs: 'Jobs can be created to email your favorites on a daily, weekly or monthly schedule. If the favorite does not return any records, an email will not be sent.',
    Lookups:
      'Lookups are queries that can be run to return a single value. The returned value can then be used as a parameter for restrictions or calculated fields.',
    OData: '',
    Widgets:
      'Widgets let you integrate your applications without copying any data. They create embeddable iframes that can be inserted into any web application.',
  },
  Documents: {
    CustomColor: 'You can add custom colors to be used in documents',
    Excel: '',
    Image: 'You can upload images to be added to a document',
    Pdf: '',
  },
  EditAction: {
    Headers: '',
    OptionalParameters:
      'This action has optional parameters that can be added to provide additional functionality',
    Parameters: '',
    RequiredParameters:
      'This action has required parameters that must be mapped to a list field or a constant value. The action will not run unless all required parameters have been mapped.',
  },
  EditApp: {
    Actions: '',
    CardsHeader: '',
    CardsSorting: '',
    Details: '',
    Environment: '',
    Fields: '',
    FormFields: '',
    Parameters: '',
    Restrictions: '',
    Widgets: '',
  },
  EditConnector: {
    Actions: '',
    CompanyMapping:
      'You can map companies to link connectors and display data from the mapped company in details and widgets',
    CustomEntities:
      'Custom lists allow you to modify and combine existing lists to create new lists',
    DataLake: {
      AddFolder:
        'All files in the folder will be combined into a single list. All files must have the same format.',
      Entities: '',
      UploadHistory: '',
    },
    Entities: '',
    Groups:
      'Groups can be used to organize your lists within the connector and make them easier to find and select',
    QueryBuilder:
      'Query builder allows you to create lists based on native queries that combine, summarize and filter tables',
  },
  EditDetail: {
    Fields: 'Select which fields you would like to show in the detail.',
    Filters: '',
    Sorting: '',
  },
  EditEndpoint: {
    Parameters:
      'Query parameters are used to filter the favorite for the endpoint. They are appended to the end of the URL after a ?, listed in key value pairs, and separated by a & ',
  },
  EditEntity: {
    Actions:
      'Actions open other web pages or run a process for a selected line in a list. They are selected by right-clicking on the line in the list.',
    CalculatedFields: 'Calculated fields are formulas that can refer to other fields in the list',
    DefaultFields:
      'Default fields are the fields that will display by default when you first open the list. Reorder the fields by dragging and dropping the rows.',
    Details:
      'Details display additional information about a selected line in a list. They can be displayed below the list, in a sidebar, or in a drill down.',
    UserVariables:
      'User variables are values that are entered by the user to send to the list as a parameter value. If a user variable is required, data will not display in the list until it has been entered.',
    CalculatedVariables:
      'Calculated variables are formulas that are calculated before sending to the list as parameter values',
    KeyFields:
      'Key fields are used to uniquely identify a row in a list. They are required to be able to use details and actions.',
    Lookups:
      'Lookups are queries that are run before a list to provide additional information to a restriction or calculated field',
    Restrictions:
      'Restrictions are fixed filters that cannot be edited by end users. They can be applied to all users or any combination of users and teams.',
  },
  EditExcel: {
    DocumentProperties: '',
    Parameters:
      'Parameters are values that can be passed in to the document. These values can be inserted anywhere in the spreadsheet or used as restriction values for a query.',
    Queries: '',
    Styles: '',
    TableStyles: '',
    Worksheets: '',
  },
  EditFavorite: {
    Sharing: {
      Teams: 'Teams that have access to this favorite',
      Users: 'Users that have access to this favorite',
    },
    Usage: {
      Users: 'Users that have recently run this favorite',
      Widgets: 'Widgets that use this favorite as a data source',
    },
  },
  EditField: {
    AddListItems: 'Enter a list of values separated by commas, with a new line for each list item',
  },
  EditFlow: {
    JsonSchema:
      "Copy this generated JSON schema into the request body of 'When a HTTP request is received' trigger in Power Automate. A URL will be generated in Power Automate that you can copy into the URL field to complete the flow setup.",
    Parameters:
      'Parameters are string, number and yes/no values that can be sent the Power Automate flow',
  },
  EditForm: {
    Action: '',
    ActionHeaders: '',
    ActionOptionalParameters:
      'This action has optional parameters that can be added to provide additional functionality',
    ActionParameters: '',
    ActionRequiredParameters:
      'This action has required parameters that must be mapped to a form field, a form parameter, or a constant value. The action will not run unless all required parameters have been mapped.',
    Fields: '',
    Parameters:
      'Hidden fields can be passed to the form and used by the form action without displaying the value on the form.',
    ValidationRules: '',
    VisibilityRules: '',
  },
  EditLookup: {
    Restrictions: '',
  },
  EditMatrixRow: {
    SummaryRow: '',
    LabelRow: '',
  },
  EditMatrixColumn: {
    Labels: '',
    SummaryItems: '',
    Filters: '',
  },
  EditPdf: {
    DocumentProperties: '',
    Footer: '',
    Header: '',
    Parameters:
      'Parameters are values that can be passed in to the document. These values can be displayed anywhere in the PDF or used as restriction values for a query.',
    Queries:
      'Queries allow you to request data from any list to include in your report. The main query returns a single record that can be used as a source for field values.',
    Sections:
      'Sections are collections of elements that can span multiple pages. A new page is started after each section.',
    Styles:
      'Styles are sets of properties for fonts, colors and borders that can be applied to style elements in your report.',
    TableStyles:
      'A table style is a set of styles to apply styles to the header, body and totals of a table. Alternate rows can be added to display a different style on every other row of a table.',
  },
  EditRestConnector: {
    GlobalVariables: '',
    Headers:
      'Request headers are HTTP headers used to provide additional metadata about the request',
    PagingPaths: 'Paging paths are values used for paging that are retrieved from an API response',
    PagingParameters:
      'Paging parameters are values used for paging that are included in API requests',
    Parameters:
      'Query parameters are appended to the end of the request URL after a ?, listed in key value pairs, and separated by a &',
    RetryErrorCodes: '',
  },
  EditRestEntity: {
    Body: '',
    Headers:
      'Request headers are HTTP headers used to provide additional metadata about the request. By default, they are appended to the headers added by the connector. If you override',
    Optimization: '',
    Parameters:
      'Query parameters are appended to the end of the request URL after a ?, listed in key value pairs, and separated by a &',
  },
  EditWidget: {
    AdvancedSearch:
      'When fields are selected for advanced search, a search field will be presented for each field. You can select the restriction type that will be performed for each field.',
    CardsHeader:
      'Select the field to be displayed in the header of each card. If your list has URL fields, you can also select a link field to open the URL when a user clicks on the header.',
    CardsSorting: 'Select the field and direction to sort the cards',
    CodeGenerator: '',
    DefaultList: '',
    Environment:
      'An environment is the application and page where a widget is embedded. Additional functionality is available when embedding in some connectors.',
    EnvironmentParameters:
      'Select values from the environment to pass through to the widget and restrict the data displayed',
    EmbedCodes: '',
    Fields: 'Select the fields to be displayed by the widget',
    Parameters:
      'Parameters are used to filter the records displayed by the widget. They are appended to the end of the iframe URL after a ?, listed in key value pairs, and separated by a & ',
    Security: '',
    TextSearch:
      'When fields are selected for text search, a single search field will be presented to the end user. Entering a value in this search field will check for the value in any of the selected fields.',
    Tokens: '',
  },
  Export: {
    CalculatedFields: '',
    Favorites: '',
    Resources: '',
  },
  Extension: {
    CompareDependencies:
      'Select a production environment to compare to your sandbox environment and find any potential issues before publishing. \n &nbsp; \n' +
      "When publishing an extension to the production environment, the extension's dependencies must all be present on the production environment. The version of the extension's dependencies must be lower or equal to the version that is installed on the production environment.",
    Dependencies:
      'Dependencies are other extensions that are required for your extension to compile. If you are using fields from a table or table extension, it must be included as a dependency.',
    Publish: '',
    Repair: '',
    Resources: '',
    ProductionDependencies: '',
  },
  ImportDynamicsGpFavorites: {
    ImportMode:
      'You can import favorites by favorite or by user. \n &nbsp; \n' +
      'When importing by favorite, you can assign a Popdock user or team to each favorite. \n &nbsp; \n' +
      'When importing by user, you can import all favorites for a Dynamics GP user and assign them to a Popdock user or team.',
    SelectUsers:
      'Select the Dynamics GP users you want to import favorites for and select the Popdock user or team that you want to have access to those favorites.',
    SelectFavorites:
      'Select the favorites that you want to import and select the Popdock user or team that you want to have access to those favorites.',
  },
  JoinedEntity: {
    JoinedEntities: '',
  },
  MatrixEntity: {
    Rows: '',
    Columns: '',
  },
  MergedEntity: {
    Entities: '',
    SpecialFields: '',
  },
  Profile: {
    Favorites: '',
    Tags: '',
    Tokens: '',
  },
  Security: {
    ApiUsers: 'API users are used to connect to external systems without logging in to Popdock',
    ChangeAdmin: 'You can have up to 2 administrators on an account',
    Firewalls: '',
    InviteUsers:
      'Enter the email addresses of the users you want to invite.\n &nbsp; \n' +
      'More than one email address can be entered, separated by a comma, space or semicolon.\n &nbsp; \n' +
      'Emails will be sent to each user asking them to verify their account.',
    Mfa:
      'You can set up your Popdock account to require an authentication code in addition to your password when you sign in. The code is generated by an application on your mobile device.\n &nbsp; \n ' +
      'After multi-factor authentication is enabled, an authentication code is generated and must be entered any time someone attempts to sign into your account. The only way someone can sign into your account is if they know both your password and have access to the authentication app on your phone.',
    PasswordPolicy:
      'A strong password policy is any organization�s first line of defense against intruders.\n &nbsp; \n' +
      'In Popdock, you can use password policies to enforce and control many different password requirements, such as complexity, length and lifetime.',
    Roles:
      'Roles are used to assign permissions to Popdock setup and management features (eg. add/edit lists, manage users) to groups of users',
    Teams: 'Teams are used to assign connectors, lists and actions to groups of users',
    VirtualNetworks: '',
  },
  SummaryEntity: {
    GroupFields: '',
    BaseRestrictions: '',
    BaseVariables: '',
  },
  Training: {
    Certifications: {
      None: '',
    },
    Courses: '',
    Sandboxes: '',
  },
};

const MfaInstructions = {
  Title: 'Secure your Popdock account',
  Explanation: 'Your organization requires you to set up multi-factor authentication',
  WhatPhone: 'What type of phone do you have?',
  Finish: 'Go to Popdock',
  InstallAppNext: "After you have installed the app, click 'Next'",
  TestCode: [
    'Enter the 6 digit code generated by the authenticator app',
    'You may want to wait until a new code is generated to give yourself enough time to enter the code',
  ],
  Microsoft: {
    InstallApp: 'On your phone, install the Microsoft Authenticator app',
    ScanCodePart1: [
      'On your phone, open the Microsoft Authenticator app',
      'Tap the plus button at the top right of the screen',
      "Select 'Other' as the kind of account you are adding",
      'Use your phone camera to scan the QR code below',
    ],
    ScanCodePart2: [
      'You should now have a new entry called Popdock in your Accounts list',
      "Click 'Next' on this page to validate your code",
    ],
  },
  Google: {
    InstallApp: 'On your phone, install the Google Authenticator app',
    ScanCodePart1: [
      'On your phone, open the Google Authenticator app',
      'Tap the plus button to open the action menu',
      "Tap the 'Scan a QR code' button",
      'Use your phone camera to scan the QR code below',
    ],
    ScanCodePart2: [
      'You should now have a new entry called Popdock in your Accounts list',
      "Click 'Next' on this page to validate your code",
    ],
  },
  Salesforce: {
    InstallApp: 'On your phone, install the Salesforce Authenticator app',
    ScanCodePart1: [
      'On your phone, open the Salesforce Authenticator app',
      "Tap the 'Add an Account' button",
      "Tap the 'Scan QR Code' link",
      'Use your phone camera to scan the QR code below',
    ],
    ScanCodePart2: [
      'Tap the Got It button',
      'You should now have a new entry called Popdock in your Accounts list',
      "Click 'Next' on this page to validate your code",
    ],
  },
  LastPass: {
    InstallApp: 'On your phone, install the LastPass app',
    ScanCodePart1: {
      Android: [
        'On your phone, open the LastPass app',
        "If this is your first account, tap the 'Add Account' button. If you already have other accounts added, tap the plus button at the bottom right of the screen.",
        'Use your phone camera to scan the QR code below',
      ],
      IPhone: [
        'On your phone, open the LastPass app',
        "If this is your first account, tap the 'Add Account' button. If you already have other accounts added, tap the plus button at the top right of the screen.",
        'Use your phone camera to scan the QR code below',
      ],
    },
    ScanCodePart2: [
      'You should now have a new entry called Popdock in your Accounts list',
      "Click 'Next' on this page to validate your code",
    ],
  },
  Authy: {
    InstallApp: 'On your phone, install the Authy app',
    ScanCodePart1: {
      Android: [
        'On your phone, open the Authy app',
        'Tap the � (menu) icon in the upper right corner, and then select Add Account',
        "Tap the 'Scan QR Code' button",
        'Use your phone camera to scan the QR code below',
      ],
      IPhone: [
        'On your phone, open the Authy app',
        'Tap the plus button',
        "Tap the 'Scan QR Code' button",
        'Use your phone camera to scan the QR code below',
      ],
    },
    ScanCodePart2: [
      '(optional) Change the nickname of your new account',
      'Tap the Save button',
      'You should now have a new tile on your Accounts list',
      "Click 'Next' on this page to validate your code",
    ],
  },
  Other: {
    InstallApp: 'On your phone, install authenticator app you would like to use',
    ScanCodePart1: [
      'On your phone, open your chosen authenticator app',
      'Add an account by scanning the QR code below',
    ],
    ScanCodePart2: ["Click 'Next' on this page to validate your code"],
  },
};

const Tooltips = {
  Account: {
    AccountId:
      'This is the unique identifier for your account. You may need to quote this for support.',
    Locale:
      'A locale is a set of language- or country-based preferences for displaying date and number values',
  },
  ChartSettings: {
    CategoryField: '',
    MaxCategories: '',
    RollingValue: '',
    ShowCategoryLabels: '',
    ShowLegend: '',
    ShowOthers: '',
    ShowValueLabels: '',
    SortField: '',
    SummaryMethod: '',
    Type: '',
    ValueField: '',
  },
  CompareEntity: {
    ComparisonType: '',
  },
  EditAction: {
    Type: '',
    TaskType: '',
    ConfirmationPrompt:
      'The message that will be displayed to confirm the action before running it',
    SubmitButtonLabel: 'The label for the button that runs the action',
    CancelButtonLabel: 'The label for the button that cancels the action',
    ApiRequest: {
      Method: '',
      Endpoint: '',
      BodyType: '',
    },
  },
  EditConnector: {
    BaseUrlForActions: '',
    CompanyPrompt: '',
    CompanyPluralPrompt: '',
    Currency: '',
    DataLake: {
      ChunkField: '',
      ChunkGranularity: {
        Date: '',
        String: '',
      },
      SkipBlankDates: '',
      SkipBlankNumbers: '',
      SkipBlankStrings: '',
      SkipEmptyTables: '',
      SplitOnField: '',
      SplitSubfolder: '',
      UploadChunks: '',
    },
    PowerAutomate: {
      Url: "Enter the HTTP POST URL that is generated by adding a 'When a HTTP request is received' trigger in Power Automate",
    },
    DuplicateEntity: {
      Name: '',
      ItemName: '',
      ItemSingular: '',
      ApiEndpoint: '',
      DuplicateFields: '',
    },
  },
  EditDashboard: {
    Type: '',
  },
  EditDetail: {
    AltTextField: '',
    DisplayType: {
      All: '',
      RightAndDrillDown: '',
    },
    IFrameUrl: '',
    ImageField: '',
    TrackingNumberField: '',
    Type: '',
  },
  EditEndpoint: {
    Endpoint: '',
    AddEndpointParameterModal: {
      Name: '',
      Field: '',
    },
  },
  EditEntity: {
    Fields: {
      CalculatedFields: '',
      DefaultFields: '',
      DragDropDefaultFields: 'Click and drag to change the order of the default fields',
      Fields: '',
    },
    ItemName: '',
    ItemSingular: '',
    AddDimensions: {
      DimensionField: 'Select the {0} that will be used to extract dimensions',
      Dimensions:
        'Select the dimensions to extract from the {0}. A field will be created for each dimension.',
      DimensionDisplayType: '',
    },
    AddRestriction: {
      Field: '',
      RestrictionType: '',
      ValueType: '',
      Value: '',
      AppliesTo:
        'Select which users the restriction will apply to. You can apply the restriction to all users or any combination of users and teams.',
    },
  },
  EditExcel: {},
  EditFavorite: {
    Locked: '',
    Owner: '',
  },
  EditField: {
    DisplayAsNegative: '',
    NegativeField: '',
    NegativeValues: '',
    SummaryMethod: {
      Numeric:
        'Select how the field will be summarized at the bottom of the grid: \n &nbsp; \n' +
        '**None** displays no summary \n &nbsp; \n' +
        '**Average** displays the total of all values divided by the number of records \n &nbsp; \n' +
        '**Count** displays the number of records \n &nbsp; \n' +
        '**Max** displays the largest value \n &nbsp; \n' +
        '**Min** displays the smallest value \n &nbsp; \n' +
        '**Sum** displays the total of all values',
      NonNumeric:
        'Select how the field will be summarized at the bottom of the grid: \n &nbsp; \n' +
        '**None** displays no summary \n &nbsp; \n' +
        '**Count** displays the number of records \n &nbsp; \n' +
        '**Max** displays the largest value \n &nbsp; \n' +
        '**Min** displays the smallest value',
    },
    ItemField: '',
    DisplayField: '',
    Path: '',
    JsonPath: '',
    FieldType: '',
    BaseTimeUnit: '',
    DisplayTimeUnit: '',
    TextFormat: '',
    DimensionField: 'Select the {0} that will be used to extract the dimension',
    Dimension: 'Select the dimension value to extract from the {0}',
    DateTimeAdjustmentMethod:
      'Select how to handle timezones for date/time fields: \n &nbsp; \n' +
      '**None** Date/time is not adjusted \n &nbsp; \n' +
      '**From UTC** Date/time is converted from UTC timezone to user timezone \n &nbsp; \n' +
      '**To UTC** Date/time is converted to UTC timezone. \n &nbsp; \n' +
      '**To User** Date/time is converted from a date/time offset to user timezone. \n &nbsp; \n' +
      '**From connector to user** Date/time is converted from connector timezone to user timezone. \n &nbsp; \n',
  },
  EditJoinEntity: {
    Sidebar: {
      Field: {
        DateSummaryMethod:
          'Changes how the date is displayed:  \n &nbsp; \n' +
          '**None** returns the date value \n &nbsp; \n' +
          '**Day** returns the day of the month (1 - 31) from the date value \n &nbsp; \n' +
          '**Month** returns the month (January - December) from the date value \n &nbsp; \n' +
          '**Year** returns the year from the date value',
        FilterOnly:
          'When selected, the field is not returned by the query and is only used for filtering the results',
        SummaryMethod:
          'The summary method changes how the value is summarized: \n &nbsp; \n' +
          '**Sum** adds the values of all fields for the specified column within a group.\n &nbsp; \n' +
          '**Count** returns the number of rows that are included in the dataset within a group\n &nbsp; \n' +
          '**Average** calculates the average value of the fields in the column within a group. When averaging fields that have an integer data type, the result is not rounded and the remainder is discarded. For example, 5�2=2 instead of 2.5 (or 2 1/2).\n &nbsp; \n' +
          '**Min** retrieves the lowest value of fields in the column within a group\n &nbsp; \n' +
          '**Max** retrieves the highest value of fields in the column within a group',
      },
      Join: {
        FromTable: '',
        ToTable: '',
        Type:
          'The join type determines the records that are included in the resulting dataset:\n &nbsp; \n ' +
          '**Left join** contains every record in the From table, even if a record does not have a matching value in the To table.\n &nbsp; \n' +
          '**Inner join** only contains records in the From table if the record has a matching value in the To table.\n &nbsp; \n' +
          '**Right join** contains every record in the To table, even if a record does not have a matching value in the From table.\n &nbsp; \n' +
          '**Full join** contains all the records in the From table and all records in the To table, even if there is no matching record.',
      },
      Table: {
        Summary: 'When selected, fields in the table can be grouped and summarized',
      },
    },
  },
  EditMatrixEntity: {
    AddMatrixColumnModal: {
      Name: '',
      SummaryMethod: '',
      Field: '',
    },
    AddMatrixDynamicRowModal: {
      Name: '',
      Field: '',
      DateFormat: '',
      SortBy: '',
      SortDirection: '',
      ApplyMaxRecords: '',
      HideEmptyRows: '',
      AddSummaryRow: '',
      Labels: '',
    },
    AddMatrixSummaryRowModal: {
      Name: '',
      SummaryMethod: '',
      Labels: '',
      Rows: '',
    },
    AddMatrixSummaryColumnModal: {
      Name: '',
      SummaryMethod: '',
      Labels: '',
      FieldType: '',
      Fields: '',
    },
  },
  EditMatrixRow: {
    Settings: {
      Name: '',
      Field: '',
      DateFormat: '',
      SortBy: '',
      SortDirection: '',
      MaxRecords: '',
      HideEmptyRows: '',
      SummaryMethod: '',
      FieldType: '',
    },
  },
  EditMatrixColumn: {
    Settings: {
      Name: '',
      SummaryMethod: '',
      Field: '',
      FieldType: '',
    },
  },
  EditRestConnector: {
    AuthenticationMethod:
      'Popdock manages the authorization to the API for a range of common authorization methods:\n &nbsp; \n' +
      '**Basic** encrypts an username and password and adds it to a header on the request\n &nbsp; \n' +
      '**Bearer token** adds a token to a header on the request\n &nbsp; \n' +
      '**Exchange token** exchanges an username and password for an access token, and then uses that token on the request\n &nbsp; \n' +
      '**OAuth 2.0** requests access and refresh tokens from the API and uses those tokens to generate future access tokens',
    BaseUrl:
      'Each request you make in Popdock is made up of a base URL and an endpoint path.\n &nbsp; \n ' +
      'For example, in the request `https://api.popdock.com/connector`, `https://api.popdock.com` is the base URL and `connector` is the endpoint path',
    BodyType:
      'When sending Post, Put and Patch requests, you may need to add different types of body data:\n &nbsp; \n ' +
      '**JSON** allows you to send data in JSON format\n &nbsp; \n ' +
      '**XML** allows you to send data in XML format\n &nbsp; \n ' +
      '**Text** allows you to send data as plain text\n &nbsp; \n ' +
      '**URL encoded form** allows you to send key-value pairs',
    CustomDateFormat: '',
    DateFormat:
      'Popdock can automatically convert a range of standard API date formats:\n &nbsp; \n ' +
      '**ISO 8601** represents date and time by starting with the year, followed by the month and the day \n &nbsp; \n ' +
      '**Epoch seconds** is the number of seconds that have elapsed since the [Unix epoch](https://en.wikipedia.org/wiki/Unix_time) \n &nbsp; \n ' +
      '**Epoch milliseconds** is the number of seconds that have elapsed since the [Unix epoch](https://en.wikipedia.org/wiki/Unix_time) \n &nbsp; \n ' +
      '**Custom** date formats can also be used by supplying a custom date format string',
    ErrorHandling: {
      MaxRetries: '',
      SleepTime: '',
    },
    ExchangeToken: {
      Endpoint: '',
      RequestMethod: '',
      BodyType: '',
      Body: '',
      TokenResponsePath: '',
      TokenExpires: '',
      TokenExpireTime: '',
    },
    OAuth2: {
      ClientId: '',
      Secret: '',
      AuthorizationUrl: '',
      AccessTokenUrl: '',
      Scope: '',
      State: '',
    },
    Paging: {
      PathType:
        '**As a request URL parameter** Add the value as a url query parameter using the supplied value as the parameter key\n &nbsp; \n' +
        '**As a request header** Add the value as a HTTP header using the supplied value as the header key',
      ParameterType:
        '**From response body** The value is retreived from the response body using supplied JSON/XML path\n &nbsp; \n' +
        '**As a request header** The value is retreived from the response headers using supplied path as the header key',
      HasMorePagesPath:
        'A true or false value that indicates that there is no more pages remaining',
      ItemCountParameter: '',
      ItemCountPath: '',
      Method:
        'Some REST APIs return data as a set of pages instead of a single result set. Popdock can handle the most common paging methods to return all data from the API:\n &nbsp; \n ' +
        '**Item count** is used when the API returns the total number of records with the first request \n &nbsp; \n ' +
        '**Next page number** is used when the API returns an integer value for the next page number, stopping when there is no value returned or the same value is returned twice \n &nbsp; \n ' +
        '**Next page link** is used when the API returns a link to the next page, stopping when there is no link returned or the same link is returned twice \n &nbsp; \n ' +
        '**Page count** is used when the API returns the total number of pages with the first request \n &nbsp; \n ' +
        '**Page offset** is used when the API requires an offset parameter (the number of records already returned) to select the page position \n &nbsp; \n ' +
        '**Custom** can be selected to implement non-standard paging methods. When this is selected, paging values can be inserted into the parameters, headers and body of each request.',
      NextPageLinkPath: '',
      NextPageNumberParameter: '',
      NextPageNumberPath: '',
      PageOffsetParameter:
        'The key value of the parameter key/value pair that sets the page offset',
      PageOffsetPath: '',
      PageCountPageParameter:
        'The HTTP header or query parameter key used to include the page number in the request',
      PageCountPageCountPath:
        'The path to the total number of pages the API make available to query',
      PageSize:
        'The number of records requested for each request. Used in conjuction with the page size parameter.',
      PageSizeParameter: 'The HTTP header or query parameter key used with the page size value',
    },
    RefreshToken: {
      RefreshTokenMethod: '',
      RefreshTokenUrl: '',
      RefreshTime: '',
    },
    RequestMethod: '',
    ResponseType: 'The file format of the response data. It can be JSON or XML.',
  },
  EditRestEntity: {
    Body: '',
    BodyType: '',
    DetailOnly: '',
    Endpoint: '',
    ParentList: '',
    RequestMethod: '',
  },
  EditLookup: {
    InputField: '',
    OutputField: '',
  },
  EditPdf: {},
  EditWidget: {
    AddAdvancedSearchField: {
      DefaultValueType: '',
    },
    AddEnvironmentParameter: {
      Parameter: '',
      Field: '',
      Lookup: '',
      Required: 'When selected, the widget will not display unless the parameter has a value',
    },
    AddParameter: {
      Name: '',
      Type: '',
      Field: '',
      Variable: '',
      Lookup: '',
      Required: 'When selected, the widget will not display unless the parameter has a value',
    },
    CodeGenerator: {
      Type: '',
      Theme: '',
      Code: {
        IFrame: '',
        Salesforce: '',
        Netsuite: '',
      },
    },
    CustomDateFormat: '',
    Environment: {
      Connector: '',
      Environment: '',
    },
    Header: {
      HeaderField: '',
      LinkField: '',
    },
    Locale:
      'A locale is a set of language- or country-based preferences for displaying date and number values. You can select a locale for the widget or use the default locale from the connector.',
    Options: {
      Export: '',
      Filter: '',
      Grouping: '',
      Totals: '',
      Columns: '',
      Refresh: '',
      Title: '',
      Search: '',
      Actions: '',
      Details: '',
      Settings: '',
      RecordCount: '',
      FilterDescription: '',
      Pages: '',
      ViewType: '',
      Favorites: '',
      AddFavorite: '',
      EditFavorite: '',
      Collapse: '',
      DefaultCollapse: '',
      TabLabel: '',
      Sidebar: '',
      EagerLoad: '',
      DisplayEmptyFields: '',
      ShowCompanies: '',
      HtmlTable: '',
    },
    Sorting: {
      Field:
        'Select the field that you want to use to sort the returned records. After a field is selected, you can changed the sort direction to Ascending or Descending',
    },
    WidgetType:
      'Select the type of widget you want to create:\n &nbsp; \n ' +
      '**Cards** displays data as a set of cards\n &nbsp; \n ' +
      '**Form** displays a data entry form that can be linked to an action\n &nbsp; \n ' +
      '**Image** displays a single image field\n &nbsp; \n ' +
      '**Multiple lists** displays a grid view with multiple lists\n &nbsp; \n ' +
      '**Search** allows for searching records in a data set and displaying the found records as a set of cards\n &nbsp; \n ' +
      '**Shipping details** displays a list of shipping details for a tracking number \n &nbsp; \n ' +
      '**Single list** displays a grid view for a single list \n &nbsp; \n ' +
      '**Single record** displays a single record\n &nbsp; \n ' +
      '**Summary** displays summary information about a data set\n &nbsp; \n ' +
      '**Widget group** allows you to display multiple widgets of different types in tabs',
  },
  EditVariable: {
    AllowMultipleValues: '',
    DefaultValue: '',
    DefaultValueType: '',
    DisplayValuesInList: '',
    Field: '',
    FieldType: '',
    Hidden: '',
    Label: '',
    Name: '',
    Required:
      'If a filter variable is required, data will not display in the list until it has been entered',
    Tooltip: 'Enter a custom tooltip to let users know how to use the filter variable',
  },
  Export: {
    ExportFileType: {
      Message: 'Select the type of export:',
      Types: {
        Connector: '**Connector** exports an entire REST connector',
        Resources:
          '**Select resources** exports a selection of Popdock resources (custom lists, details, actions) to export',
        Favorites: '**Favorites** exports a selection of favorites',
        FieldSettings: '**Field settings** exports all field settings for a connector',
        CalculatedFields: '**Calculated fields** exports a selection of calculated fields',
        FiscalYears: '**Fiscal years** exports a selection of fiscal years',
        EmbeddedApp: '**App** exports an app and all widgets within that app',
      },
    },
    FileName:
      'Enter the name of the file that you want to export to. The file will be downloaded to your Downloads folder.',
    Description:
      'Enter a description for the export. This description will be displayed when the file is imported.',
  },
  Extension: {
    CompareToConnector: '',
    FirstResourceId:
      'All objects in Business Central customizations must have a unique object ID. To avoid overlap with other customizations, you can change the first resource ID that Popdock uses.\n &nbsp; \n' +
      'This ID must be in the 50,000-99,999 range.',
    Version: '',
    SandboxConnector:
      'Select the sandbox connector that contains the extension you want to publish to production',
  },
  Filter: {
    CompareFields: 'Compare fields. Click to change to enter value.',
    EnterValue: 'Enter value. Click to change to compare fields.',
  },
  Import: {
    ImportFile: '',
  },
  Permissions: {
    AddAction: '',
    AddCalculatedField: '',
    AddNewConnectors: '',
    AddList: '',
    AddRestConnector: '',
    AppStoreAppStore: '',
    AssignTeamSecurity: '',
    AssignUserSecurity: '',
    CreateEmailDocument: '',
    CreateExcelDocument: '',
    CreatePdfDocument: '',
    CreateWidgets: '',
    CreateWorkflow: '',
    DeleteConnector: '',
    EditConnectorLabels: '',
    EditFieldOptions: '',
    ExportSolution: '',
    ExportToExcel: '',
    ExportToPdf: '',
    InstallApp: '',
    ImportSolution: '',
    ManageCompanies: '',
    ManageDataLake: '',
    ManageEndpoints: '',
    ManageFavorite: '',
    ManageGroups: '',
    ManageRelationships: '',
    ManageRoles: '',
    ManageTeam: '',
    ManageTokens: '',
    QueryBuilder: '',
    QueryBuilderPublish: '',
    RefreshConnector: '',
    RunAction: '',
    RunWorkflow: '',
    Schedule: '',
    ViewApi: '',
    WidgetPublish: '',
  },
  Profile: {
    DisableNotifications: '',
    GridColumnSizingMethod: '',
    Locale: '',
    PageSize: '',
    SessionTimeout: '',
    ShowPages: '',
    Theme: '',
    TimeZone: '',
  },
  QueryBuilder: {
    ApiName: '',
    Sidebar: {
      Field: {
        Alias:
          'Each field returned by the query must have a unique name. The alias for a field is the name that is returned by the query. It defaults to the name of the field and can be changed to ensure uniqueness.',
        DateSummaryMethod:
          'Changes how the date is displayed:  \n &nbsp; \n' +
          '**None** returns the date value \n &nbsp; \n' +
          '**Day** returns the day of the month (1 - 31) from the date value \n &nbsp; \n' +
          '**Month** returns the month (January - December) from the date value \n &nbsp; \n' +
          '**Year** returns the year from the date value',
        FilterOnly:
          'When selected, the field is not returned by the query and is only used for filtering the results',
        ReverseSign:
          'Changes negative values into positive values and positive values into negative values',
        SummaryMethod:
          'The summary method changes how the value is summarized: \n &nbsp; \n' +
          '**Sum** adds the values of all fields for the specified column within a group.\n &nbsp; \n' +
          '**Count** returns the number of rows that are included in the dataset within a group\n &nbsp; \n' +
          '**Average** calculates the average value of the fields in the column within a group. When averaging fields that have an integer data type, the result is not rounded and the remainder is discarded. For example, 5�2=2 instead of 2.5 (or 2 1/2).\n &nbsp; \n' +
          '**Min** retrieves the lowest value of fields in the column within a group\n &nbsp; \n' +
          '**Max** retrieves the highest value of fields in the column within a group',
      },
      Join: {
        FromTable: '',
        ToTable: '',
        Type:
          'The join type determines the records that are included in the resulting dataset:\n &nbsp; \n ' +
          '**Left join** contains every record in the From table, even if a record does not have a matching value in the To table.\n &nbsp; \n' +
          '**Inner join** only contains records in the From table if the record has a matching value in the To table.\n &nbsp; \n' +
          '**Right join** contains every record in the To table, even if a record does not have a matching value in the From table.\n &nbsp; \n' +
          '**Full join** contains all the records in the From table and all records in the To table, even if there is no matching record.\n &nbsp; \n' +
          '**Cross join** contains rows that combine each row from the From table with each row from the To table.',
      },
      Table: {
        Alias: 'Each table in the query must have a unique name',
        Summary: 'When selected, fields in the table can be grouped and summarized',
      },
    },
  },
  Security: {
    MfaEnabledFor:
      'Multi-factor authentication can be enabled for any subset of Popdock users:\n &nbsp; \n ' +
      'When **Enabled for all users** is selected, all Popdock users must use multi-factor authentication \n &nbsp; \n ' +
      'When **Enabled for all administrators** is selected, all administrator users must use multi-factor authentication \n &nbsp; \n ' +
      'When **Enabled for selected users** is selected, you can select which users require multi-factor authentication on the Users tab \n &nbsp; \n ' +
      'When **Enabled for selected roles** is selected, you can select which roles require multi-factor authentication on the Roles tab. All users that are members of the selected roles must use multi-factor authentication. \n &nbsp; \n ' +
      'When **Enabled for selected teams** is selected, you can select which teams require multi-factor authentication on the Teams tab. All users that are members of the selected teams must use multi-factor authentication.',
    PasswordPolicy: {
      PasswordExpires: '',
      PasswordPreventReuse: '',
    },
  },
  TextSettings: {
    Format: '',
    RemoveBlanks:
      'When selected, fields are removed from the record when the value is blank or null',
    ShowHeaders: 'When selected, a header row is added to the file',
  },
};

const Operators = {
  Equals: 'Equals',
  NotEquals: 'Does not equal',
  OneOfList: 'One of list',
  NotOneOfList: 'Not one of list',
  Between: 'Between',
  NotBetween: 'Not between',
  Greater: 'Greater than',
  Less: 'Less than',
  GreaterEqual: 'Greater than or equal to',
  LessEqual: 'Less than or equal to',
  Contains: 'Contains',
  StartsWith: 'Starts with',
  EndsWith: 'Ends with',
  NotContains: 'Does not contain',
  NotStartsWith: 'Does not start with',
  NotEndsWith: 'Does not end with',
  Null: 'Is null',
  NotNull: 'Is not null',
};

const DateValues = {
  Today: 'Today',
  Yesterday: 'Yesterday',
  Tomorrow: 'Tomorrow',
  StartOfWeek: 'Start of week',
  EndOfWeek: 'End of week',
  StartOfMonth: 'Start of month',
  EndOfMonth: 'End of month',
  StartOfQuarter: 'Start of quarter',
  EndOfQuarter: 'End of quarter',
  StartOfYear: 'Start of year',
  EndOfYear: 'End of year',
  StartOfThisFiscalPeriod: 'Start of fiscal period',
  EndOfThisFiscalPeriod: 'End of fiscal period',
  StartOfLastWeek: 'Start of last week',
  EndOfLastWeek: 'End of last week',
  StartOfLastMonth: 'Start of last month',
  EndOfLastMonth: 'End of last month',
  StartOfLastQuarter: 'Start of last quarter',
  EndOfLastQuarter: 'End of last quarter',
  StartOfLastYear: 'Start of last year',
  EndOfLastYear: 'End of last year',
  StartOfLastFiscalPeriod: 'Start of last fiscal period',
  EndOfLastFiscalPeriod: 'End of last fiscal period',
  StartOfNextWeek: 'Start of next week',
  EndOfNextWeek: 'End of next week',
  StartOfNextMonth: 'Start of next month',
  EndOfNextMonth: 'End of next month',
  StartOfNextQuarter: 'Start of next quarter',
  EndOfNextQuarter: 'End of next quarter',
  StartOfNextYear: 'Start of next year',
  EndOfNextYear: 'End of next year',
  StartOfNextFiscalPeriod: 'Start of next fiscal period',
  EndOfNextFiscalPeriod: 'End of next fiscal period',
  ThisWeek: 'This week',
  LastWeek: 'Last week',
  NextWeek: 'Next week',
  ThisMonth: 'This month',
  LastMonth: 'Last month',
  NextMonth: 'Next month',
  ThisQuarter: 'This quarter',
  LastQuarter: 'Last quarter',
  NextQuarter: 'Next quarter',
  ThisYear: 'This year',
  LastYear: 'Last year',
  NextYear: 'Next year',
  ThisFiscalPeriod: 'This fiscal period',
  LastFiscalPeriod: 'Last fiscal period',
  NextFiscalPeriod: 'Next fiscal period',
  StartOfThisFiscalYear: 'Start of fiscal year',
  EndOfThisFiscalYear: 'End of fiscal year',
  StartOfLastFiscalYear: 'Start of last fiscal year',
  EndOfLastFiscalYear: 'End of last fiscal year',
  StartOfNextFiscalYear: 'Start of next fiscal year',
  EndOfNextFiscalYear: 'End of next fiscal year',
  ThisFiscalYear: 'This fiscal year',
  LastFiscalYear: 'Last fiscal year',
  NextFiscalYear: 'Next fiscal year',
};

const DateFormats = {
  Date: 'Date',
  Day: 'Day',
  DayOfWeek: 'Day of week',
  Month: 'Month',
  Year: 'Year',
  MonthYear: 'Year-Month',
  FiscalPeriod: 'Fiscal period',
  FiscalYear: 'Fiscal year',
  FiscalPeriodYear: 'Fiscal period/year',
};

const SummaryMethods = {
  Average: 'Average',
  Sum: 'Sum',
  Max: 'Maximum',
  Min: 'Minimum',
  Count: 'Count',
  GroupBy: 'Group by',
  None: 'None',
  Rank: 'Rank',
  RankNoTies: 'Rank (no ties)',
  Median: 'Median',
  Mode: 'Mode',
  StandardDeviation: 'Standard deviation',
  Variance: 'Variance',
  DistinctCount: 'Distinct count',
  DistinctValue: 'Distinct values',
  First: 'First',
  Last: 'Last',
};

const TextFormats = {
  Plain: 'Plain text',
  Html: 'HTML',
  Markdown: 'Markdown',
};

const Formats = {
  Locale: 'en-US',
  Currency: 'USD',
  Date: 'M/D/YYYY',
  Day: 'D',
  Month: 'MMMM',
  Year: 'YYYY',
  MonthYear: 'MMMM YYYY',
  DayOfWeek: 'dddd',
  Time: 'hh:mm',
  GridDate: '{0: M/d/yyyy}',
  GridDay: '{0: d}',
  GridMonth: '{0: MMMM}',
  GridYear: '{0: yyyy}',
  GridMonthYear: '{0: MMMM yyyy}',
  GridDayOfWeek: '{0: dddd}',
  GridTime: '{0: hh:mm tt}',
  TextDate: 'YYYY-MM-DD',
};

const CustomEntityTypes = {
  Summary: 'Summary',
  Joined: 'Joined',
  Merged: 'Merged',
  Comparison: 'Comparison',
  Restriction: 'Restriction',
  Matrix: 'Matrix',
};

const ConnectorSetupLabels = {
  AccountId: 'Account ID',
  AdminUsername: 'Admin username',
  ApiKey: 'API key',
  CompanyId: 'Company ID',
  Database: 'Database',
  MerchantId: 'Merchant ID',
  OrganizationLink: 'Organization link',
  Password: 'Password',
  Port: 'Port',
  Prefix: 'Prefix',
  PrivateKey: 'Private key',
  PublicKey: 'Public key',
  Server: 'Server',
  StoreLink: 'Store link',
  Username: 'Username',
  WebAccessToken: 'Web access token',
  Accounting: 'Accounting',
  CRM: 'CRM',
  Webstore: 'Web store',
  Helpdesk: 'Helpdesk',
  SocialMedia: 'Social media',
  MailingList: 'Email marketing',
  Payments: 'Payments',
  TenantId: 'Tenant ID',
};

const InvoiceLabels = {
  InvoiceNumber: 'Invoice number',
  Date: 'Invoice date',
  From: 'From',
  To: 'To',
  Status: 'Status',
  Description: 'Description',
  Quantity: 'Quantity',
  UnitPrice: 'Unit price',
  Subtotal: 'Subtotal',
  Tax: 'Tax',
  Total: 'Total',
  ThankYou: 'Thank you for doing business with Popdock',
};

const ConnectorSetupPlaceholders = {
  SqlUsername: 'sqluser',
  DynamicsDatabase: 'DYNAMICS',
  Password: 'password',
  SqlServer: 'sql.database.windows.net',
};

const ConnectorSetupTooltips = {
  EnterDynamicsDatabase: 'Enter the name of your system (DYNAMICS) database',
  BCUsername: 'This will be the username, not your authentication email',
  BCToken: 'Located on your User Card, be sure to copy the full Web Service Access Key.',
  BCTenantId: 'Please locate your Tenant ID in your BC url or use www.whatismytenantid.com',
};

const ConnectorSetupMessages = {
  SelectAccounting: 'Select your accounting application',
  SelectCRM: 'Select your CRM application',
  SelectWebstore: 'Select all of the web stores that you sell on',
  SelectHelpdesk: 'Select your helpdesk application',
  SelectSocialMedia: 'Select all of the social media platforms you use',
  SelectMailingList: 'Select the application you use to send emails',
  SelectPayments: 'Select all of the payment applications you use',
};

const ApiRequestMethods = {
  Get: 'GET',
  Post: 'POST',
  Patch: 'PATCH',
  Delete: 'DELETE',
  Put: 'PUT',
};

const PageSizes = {
  A0: 'A0',
  A1: 'A1',
  A2: 'A2',
  A3: 'A3',
  A4: 'A4',
  A5: 'A5',
  A6: 'A6',
  A7: 'A7',
  A8: 'A8',
  A9: 'A9',
  A10: 'A10',
  B0: 'B0',
  B1: 'B1',
  B2: 'B2',
  B3: 'B3',
  B4: 'B4',
  B5: 'B5',
  B6: 'B6',
  B7: 'B7',
  B8: 'B8',
  B9: 'B9',
  B10: 'B10',
  C0: 'C0',
  C1: 'C1',
  C2: 'C2',
  C3: 'C3',
  C4: 'C4',
  C5: 'C5',
  C6: 'C6',
  C7: 'C7',
  C8: 'C8',
  C9: 'C9',
  C10: 'C10',
  Executive: 'Executive',
  Folio: 'Folio',
  Legal: 'Legal',
  Letter: 'Letter',
  Tabloid: 'Tabloid',
};

const Countries = [
  { Key: 'USA', Value: 'United States of America' },
  { Key: '-', Value: '-' },
  { Key: 'AFG', Value: 'Afghanistan' },
  { Key: 'ALA', Value: 'Åland' },
  { Key: 'ALB', Value: 'Albania' },
  { Key: 'DZA', Value: 'Algeria' },
  { Key: 'ASM', Value: 'American Samoa' },
  { Key: 'AND', Value: 'Andorra' },
  { Key: 'AGO', Value: 'Angola' },
  { Key: 'AIA', Value: 'Anguilla' },
  { Key: 'ATA', Value: 'Antarctica' },
  { Key: 'ATG', Value: 'Antigua and Barbuda' },
  { Key: 'ARG', Value: 'Argentina' },
  { Key: 'ARM', Value: 'Armenia' },
  { Key: 'ABW', Value: 'Aruba' },
  { Key: 'AUS', Value: 'Australia' },
  { Key: 'AUT', Value: 'Austria' },
  { Key: 'AZE', Value: 'Azerbaijan' },
  { Key: 'BHS', Value: 'Bahamas' },
  { Key: 'BHR', Value: 'Bahrain' },
  { Key: 'BGD', Value: 'Bangladesh' },
  { Key: 'BRB', Value: 'Barbados' },
  { Key: 'BLR', Value: 'Belarus' },
  { Key: 'BEL', Value: 'Belgium' },
  { Key: 'BLZ', Value: 'Belize' },
  { Key: 'BEN', Value: 'Benin' },
  { Key: 'BMU', Value: 'Bermuda' },
  { Key: 'BTN', Value: 'Bhutan' },
  { Key: 'BOL', Value: 'Bolivia' },
  { Key: 'BES', Value: 'Bonaire, Sint Eustatius and Saba' },
  { Key: 'BIH', Value: 'Bosnia and Herzegovina' },
  { Key: 'BWA', Value: 'Botswana' },
  { Key: 'BVT', Value: 'Bouvet Island' },
  { Key: 'BRA', Value: 'Brazil' },
  { Key: 'IOT', Value: 'British Indian Ocean Territory' },
  { Key: 'BRN', Value: 'Brunei Darussalam' },
  { Key: 'BGR', Value: 'Bulgaria' },
  { Key: 'BFA', Value: 'Burkina Faso' },
  { Key: 'BDI', Value: 'Burundi' },
  { Key: 'KHM', Value: 'Cambodia' },
  { Key: 'CMR', Value: 'Cameroon' },
  { Key: 'CAN', Value: 'Canada' },
  { Key: 'CPV', Value: 'Cape Verde' },
  { Key: 'CYM', Value: 'Cayman Islands' },
  { Key: 'CAF', Value: 'Central African Republic' },
  { Key: 'TCD', Value: 'Chad' },
  { Key: 'CHL', Value: 'Chile' },
  { Key: 'CHN', Value: 'China' },
  { Key: 'CXR', Value: 'Christmas Island' },
  { Key: 'CCK', Value: 'Cocos (Keeling) Islands' },
  { Key: 'COL', Value: 'Colombia' },
  { Key: 'COM', Value: 'Comoros' },
  { Key: 'COG', Value: 'Congo (Brazzaville)' },
  { Key: 'COD', Value: 'Congo (Kinshasa)' },
  { Key: 'COK', Value: 'Cook Islands' },
  { Key: 'CRI', Value: 'Costa Rica' },
  { Key: 'CIV', Value: "Côte d'Ivoire" },
  { Key: 'HRV', Value: 'Croatia' },
  { Key: 'CUB', Value: 'Cuba' },
  { Key: 'CUW', Value: 'Curaçao' },
  { Key: 'CYP', Value: 'Cyprus' },
  { Key: 'CZE', Value: 'Czech Republic' },
  { Key: 'DNK', Value: 'Denmark' },
  { Key: 'DJI', Value: 'Djibouti' },
  { Key: 'DMA', Value: 'Dominica' },
  { Key: 'DOM', Value: 'Dominican Republic' },
  { Key: 'ECU', Value: 'Ecuador' },
  { Key: 'EGY', Value: 'Egypt' },
  { Key: 'SLV', Value: 'El Salvador' },
  { Key: 'GNQ', Value: 'Equatorial Guinea' },
  { Key: 'ERI', Value: 'Eritrea' },
  { Key: 'EST', Value: 'Estonia' },
  { Key: 'ETH', Value: 'Ethiopia' },
  { Key: 'FLK', Value: 'Falkland Islands' },
  { Key: 'FRO', Value: 'Faroe Islands' },
  { Key: 'FJI', Value: 'Fiji' },
  { Key: 'FIN', Value: 'Finland' },
  { Key: 'FRA', Value: 'France' },
  { Key: 'GUF', Value: 'French Guiana' },
  { Key: 'PYF', Value: 'French Polynesia' },
  { Key: 'ATF', Value: 'French Southern Lands' },
  { Key: 'GAB', Value: 'Gabon' },
  { Key: 'GMB', Value: 'Gambia' },
  { Key: 'GEO', Value: 'Georgia' },
  { Key: 'DEU', Value: 'Germany' },
  { Key: 'GHA', Value: 'Ghana' },
  { Key: 'GIB', Value: 'Gibraltar' },
  { Key: 'GRC', Value: 'Greece' },
  { Key: 'GRL', Value: 'Greenland' },
  { Key: 'GRD', Value: 'Grenada' },
  { Key: 'GLP', Value: 'Guadeloupe' },
  { Key: 'GUM', Value: 'Guam' },
  { Key: 'GTM', Value: 'Guatemala' },
  { Key: 'GGY', Value: 'Guernsey' },
  { Key: 'GIN', Value: 'Guinea' },
  { Key: 'GNB', Value: 'Guinea-Bissau' },
  { Key: 'GUY', Value: 'Guyana' },
  { Key: 'HTI', Value: 'Haiti' },
  { Key: 'HMD', Value: 'Heard and McDonald Islands' },
  { Key: 'HND', Value: 'Honduras' },
  { Key: 'HKG', Value: 'Hong Kong' },
  { Key: 'HUN', Value: 'Hungary' },
  { Key: 'ISL', Value: 'Iceland' },
  { Key: 'IND', Value: 'India' },
  { Key: 'IDN', Value: 'Indonesia' },
  { Key: 'IRN', Value: 'Iran' },
  { Key: 'IRQ', Value: 'Iraq' },
  { Key: 'IRL', Value: 'Ireland' },
  { Key: 'IMN', Value: 'Isle of Man' },
  { Key: 'ISR', Value: 'Israel' },
  { Key: 'ITA', Value: 'Italy' },
  { Key: 'JAM', Value: 'Jamaica' },
  { Key: 'JPN', Value: 'Japan' },
  { Key: 'JEY', Value: 'Jersey' },
  { Key: 'JOR', Value: 'Jordan' },
  { Key: 'KAZ', Value: 'Kazakhstan' },
  { Key: 'KEN', Value: 'Kenya' },
  { Key: 'KIR', Value: 'Kiribati' },
  { Key: 'PRK', Value: 'Korea, North' },
  { Key: 'KOR', Value: 'Korea, South' },
  { Key: 'KWT', Value: 'Kuwait' },
  { Key: 'KGZ', Value: 'Kyrgyzstan' },
  { Key: 'LAO', Value: 'Laos' },
  { Key: 'LVA', Value: 'Latvia' },
  { Key: 'LBN', Value: 'Lebanon' },
  { Key: 'LSO', Value: 'Lesotho' },
  { Key: 'LBR', Value: 'Liberia' },
  { Key: 'LBY', Value: 'Libya' },
  { Key: 'LIE', Value: 'Liechtenstein' },
  { Key: 'LTU', Value: 'Lithuania' },
  { Key: 'LUX', Value: 'Luxembourg' },
  { Key: 'MAC', Value: 'Macau' },
  { Key: 'MKD', Value: 'Macedonia' },
  { Key: 'MDG', Value: 'Madagascar' },
  { Key: 'MWI', Value: 'Malawi' },
  { Key: 'MYS', Value: 'Malaysia' },
  { Key: 'MDV', Value: 'Maldives' },
  { Key: 'MLI', Value: 'Mali' },
  { Key: 'MLT', Value: 'Malta' },
  { Key: 'MHL', Value: 'Marshall Islands' },
  { Key: 'MTQ', Value: 'Martinique' },
  { Key: 'MRT', Value: 'Mauritania' },
  { Key: 'MUS', Value: 'Mauritius' },
  { Key: 'MYT', Value: 'Mayotte' },
  { Key: 'MEX', Value: 'Mexico' },
  { Key: 'FSM', Value: 'Micronesia' },
  { Key: 'MDA', Value: 'Moldova' },
  { Key: 'MCO', Value: 'Monaco' },
  { Key: 'MNG', Value: 'Mongolia' },
  { Key: 'MNE', Value: 'Montenegro' },
  { Key: 'MSR', Value: 'Montserrat' },
  { Key: 'MAR', Value: 'Morocco' },
  { Key: 'MOZ', Value: 'Mozambique' },
  { Key: 'MMR', Value: 'Myanmar' },
  { Key: 'NAM', Value: 'Namibia' },
  { Key: 'NRU', Value: 'Nauru' },
  { Key: 'NPL', Value: 'Nepal' },
  { Key: 'NLD', Value: 'Netherlands' },
  { Key: 'ANT', Value: 'Netherlands Antilles' },
  { Key: 'NCL', Value: 'New Caledonia' },
  { Key: 'NZL', Value: 'New Zealand' },
  { Key: 'NIC', Value: 'Nicaragua' },
  { Key: 'NER', Value: 'Niger' },
  { Key: 'NGA', Value: 'Nigeria' },
  { Key: 'NIU', Value: 'Niue' },
  { Key: 'NFK', Value: 'Norfolk Island' },
  { Key: 'MNP', Value: 'Northern Mariana Islands' },
  { Key: 'NOR', Value: 'Norway' },
  { Key: 'OMN', Value: 'Oman' },
  { Key: 'PAK', Value: 'Pakistan' },
  { Key: 'PLW', Value: 'Palau' },
  { Key: 'PSE', Value: 'Palestine' },
  { Key: 'PAN', Value: 'Panama' },
  { Key: 'PNG', Value: 'Papua New Guinea' },
  { Key: 'PRY', Value: 'Paraguay' },
  { Key: 'PER', Value: 'Peru' },
  { Key: 'PHL', Value: 'Philippines' },
  { Key: 'PCN', Value: 'Pitcairn' },
  { Key: 'POL', Value: 'Poland' },
  { Key: 'PRT', Value: 'Portugal' },
  { Key: 'PRI', Value: 'Puerto Rico' },
  { Key: 'QAT', Value: 'Qatar' },
  { Key: 'REU', Value: 'Reunion' },
  { Key: 'ROU', Value: 'Romania' },
  { Key: 'RUS', Value: 'Russian Federation' },
  { Key: 'RWA', Value: 'Rwanda' },
  { Key: 'BLM', Value: 'Saint Barthélemy' },
  { Key: 'SHN', Value: 'Saint Helena' },
  { Key: 'KNA', Value: 'Saint Kitts and Nevis' },
  { Key: 'LCA', Value: 'Saint Lucia' },
  { Key: 'MAF', Value: 'Saint Martin (French part)' },
  { Key: 'SPM', Value: 'Saint Pierre and Miquelon' },
  { Key: 'VCT', Value: 'Saint Vincent and the Grenadines' },
  { Key: 'WSM', Value: 'Samoa' },
  { Key: 'SMR', Value: 'San Marino' },
  { Key: 'STP', Value: 'Sao Tome and Principe' },
  { Key: 'SAU', Value: 'Saudi Arabia' },
  { Key: 'SEN', Value: 'Senegal' },
  { Key: 'SRB', Value: 'Serbia' },
  { Key: 'SYC', Value: 'Seychelles' },
  { Key: 'SLE', Value: 'Sierra Leone' },
  { Key: 'SGP', Value: 'Singapore' },
  { Key: 'SXM', Value: 'Sint Maarten (Dutch part)' },
  { Key: 'SVK', Value: 'Slovakia' },
  { Key: 'SVN', Value: 'Slovenia' },
  { Key: 'SLB', Value: 'Solomon Islands' },
  { Key: 'SOM', Value: 'Somalia' },
  { Key: 'ZAF', Value: 'South Africa' },
  { Key: 'SGS', Value: 'South Georgia and South Sandwich Islands' },
  { Key: 'SSD', Value: 'South Sudan' },
  { Key: 'ESP', Value: 'Spain' },
  { Key: 'LKA', Value: 'Sri Lanka' },
  { Key: 'SDN', Value: 'Sudan' },
  { Key: 'SUR', Value: 'Suriname' },
  { Key: 'SJM', Value: 'Svalbard and Jan Mayen Islands' },
  { Key: 'SWZ', Value: 'Swaziland' },
  { Key: 'SWE', Value: 'Sweden' },
  { Key: 'CHE', Value: 'Switzerland' },
  { Key: 'SYR', Value: 'Syria' },
  { Key: 'TWN', Value: 'Taiwan' },
  { Key: 'TJK', Value: 'Tajikistan' },
  { Key: 'TZA', Value: 'Tanzania' },
  { Key: 'THA', Value: 'Thailand' },
  { Key: 'TLS', Value: 'Timor-Leste' },
  { Key: 'TGO', Value: 'Togo' },
  { Key: 'TKL', Value: 'Tokelau' },
  { Key: 'TON', Value: 'Tonga' },
  { Key: 'TTO', Value: 'Trinidad and Tobago' },
  { Key: 'TUN', Value: 'Tunisia' },
  { Key: 'TUR', Value: 'Turkiye' },
  { Key: 'TKM', Value: 'Turkmenistan' },
  { Key: 'TCA', Value: 'Turks and Caicos Islands' },
  { Key: 'TUV', Value: 'Tuvalu' },
  { Key: 'UGA', Value: 'Uganda' },
  { Key: 'UKR', Value: 'Ukraine' },
  { Key: 'ARE', Value: 'United Arab Emirates' },
  { Key: 'GBR', Value: 'United Kingdom' },
  { Key: 'UMI', Value: 'United States Minor Outlying Islands' },
  { Key: 'URY', Value: 'Uruguay' },
  { Key: 'UZB', Value: 'Uzbekistan' },
  { Key: 'VUT', Value: 'Vanuatu' },
  { Key: 'VAT', Value: 'Vatican City' },
  { Key: 'VEN', Value: 'Venezuela' },
  { Key: 'VNM', Value: 'Vietnam' },
  { Key: 'VGB', Value: 'Virgin Islands, British' },
  { Key: 'VIR', Value: 'Virgin Islands, U.S.' },
  { Key: 'WLF', Value: 'Wallis and Futuna Islands' },
  { Key: 'ESH', Value: 'Western Sahara' },
  { Key: 'YEM', Value: 'Yemen' },
  { Key: 'ZMB', Value: 'Zambia' },
  { Key: 'ZWE', Value: 'Zimbabwe' },
];
const UsStates = [
  { Key: 'AL', Value: 'Alabama' },
  { Key: 'AK', Value: 'Alaska' },
  { Key: 'AZ', Value: 'Arizona' },
  { Key: 'AR', Value: 'Arkansas' },
  { Key: 'CA', Value: 'California' },
  { Key: 'CO', Value: 'Colorado' },
  { Key: 'CT', Value: 'Connecticut' },
  { Key: 'DE', Value: 'Delaware' },
  { Key: 'DC', Value: 'District Of Columbia' },
  { Key: 'FL', Value: 'Florida' },
  { Key: 'GA', Value: 'Georgia' },
  { Key: 'HI', Value: 'Hawaii' },
  { Key: 'ID', Value: 'Idaho' },
  { Key: 'IL', Value: 'Illinois' },
  { Key: 'IN', Value: 'Indiana' },
  { Key: 'IA', Value: 'Iowa' },
  { Key: 'KS', Value: 'Kansas' },
  { Key: 'KY', Value: 'Kentucky' },
  { Key: 'LA', Value: 'Louisiana' },
  { Key: 'ME', Value: 'Maine' },
  { Key: 'MD', Value: 'Maryland' },
  { Key: 'MA', Value: 'Massachusetts' },
  { Key: 'MI', Value: 'Michigan' },
  { Key: 'MN', Value: 'Minnesota' },
  { Key: 'MS', Value: 'Mississippi' },
  { Key: 'MO', Value: 'Missouri' },
  { Key: 'MT', Value: 'Montana' },
  { Key: 'NE', Value: 'Nebraska' },
  { Key: 'NV', Value: 'Nevada' },
  { Key: 'NH', Value: 'New Hampshire' },
  { Key: 'NJ', Value: 'New Jersey' },
  { Key: 'NM', Value: 'New Mexico' },
  { Key: 'NY', Value: 'New York' },
  { Key: 'NC', Value: 'North Carolina' },
  { Key: 'ND', Value: 'North Dakota' },
  { Key: 'OH', Value: 'Ohio' },
  { Key: 'OK', Value: 'Oklahoma' },
  { Key: 'OR', Value: 'Oregon' },
  { Key: 'PA', Value: 'Pennsylvania' },
  { Key: 'RI', Value: 'Rhode Island' },
  { Key: 'SC', Value: 'South Carolina' },
  { Key: 'SD', Value: 'South Dakota' },
  { Key: 'TN', Value: 'Tennessee' },
  { Key: 'TX', Value: 'Texas' },
  { Key: 'UT', Value: 'Utah' },
  { Key: 'VT', Value: 'Vermont' },
  { Key: 'VA', Value: 'Virginia' },
  { Key: 'WA', Value: 'Washington' },
  { Key: 'WV', Value: 'West Virginia' },
  { Key: 'WI', Value: 'Wisconsin' },
  { Key: 'WY', Value: 'Wyoming' },
];

const DataLakeChunkGranularity = {
  Date: {
    Day: 'Day',
    Month: 'Month',
    Year: 'Year',
  },
  String: {
    None: 'None',
    OneChar: 'First character',
    TwoChars: 'First 2 characters',
    ThreeChars: 'First 3 characters',
    FourChars: 'First 4 characters',
    FiveChars: 'First 5 characters',
  },
};

const ScriptLanguages = {
  Csharp: 'C#',
  Popdock: 'Popdock script',
};

const JobTypes = {
  SendEmail: 'Send email',
  Export: 'Export',
};

const JobEmailAttachmentFormats = {
  Excel: 'Excel',
  Csv: 'CSV',
};

const SidebarWidgetSizes = {
  Small: 'Small',
  Medium: 'Medium',
  Large: 'Large',
};

const WidgetParameterTypes = {
  Field: 'Add filter on field',
  Variable: 'Set variable',
};

const MfaAuthenticatorApps = {
  Microsoft: 'Microsoft Authenticator',
  Google: 'Google Authenticator',
  Salesforce: 'Salesforce Authenticator',
  LastPass: 'LastPass',
  Authy: 'Authy',
  Other: 'Other',
};

const Permissions = {
  ExportToExcel: 'Export data to Excel',
  AddConnector: 'Add new connectors',
  DeleteConnector: 'Delete connectors',
  RefreshConnector: 'Refresh connectors',
  ManageTeam: 'Manage teams',
  AssignTeamSecurity: 'Assign security to teams',
  AssignUserSecurity: 'Assign security to users',
  AddList: 'Add new lists',
  AddCalculatedField: 'Add calculated fields',
  EditConnectorLabels: 'Edit labels',
  ManageGroups: 'Manage groups',
  ManageRelationships: 'Manage details',
  EditFieldOptions: 'Edit field options',
  ManageRoles: 'Manage roles',
  CreateWidgets: 'Create widgets',
  ManageTokens: 'Manage tokens',
  ManageEndpoints: 'Create custom API endpoints',
  Schedule: 'Schedule jobs',
  InstallApp: 'Install apps',
  ExportSolution: 'Export customizations',
  ImportSolution: 'Import customizations',
  AddAction: 'Add actions',
  AddRestConnector: 'Add REST connectors',
  ManageCompanies: 'Manage companies',
  ViewApi: 'View API documentation',
  ExportToPdf: 'Export data to a PDF',
  QueryBuilder: 'Create Query Builder lists',
  QueryBuilderPublish: 'Publish Query Builder lists',
  WidgetPublish: 'Publish widgets',
  CreateExcelDocument: 'Create Excel templates',
  CreatePdfDocument: 'Create PDF templates',
  CreateEmailDocument: 'Create email templates',
  AppStore: 'Browse the app store',
  CreateWorkflow: 'Create workflows',
  RunWorkflow: 'Run workflows',
  RunAction: 'Run actions',
  ManageDataLake: 'Upload files to data lakes',
  ManageFavorite: 'Manage favorites',
};

const Prompts = {
  OrSelectAFile: 'or click here to select a file',
};

const HomePageColors = {
  Blue: 'Blue',
  Green: 'Green',
  Red: 'Red',
  Yellow: 'Yellow',
  Orange: 'Orange',
  Purple: 'Purple',
  Grey: 'Grey',
  White: 'White',
  DarkBlue: 'Dark blue',
};

const ActionDisplayTypes = {
  Background: 'Run as a background process',
  Form: 'Display a form',
  Confirmation: 'Display a confirmation prompt',
};

const FirewallTypes = {
  WebApp: 'Web application',
  Api: 'API',
  Excel: 'Excel addin',
  Widgets: 'Widgets',
};

const TimespanUnits = {
  Second: 'Seconds',
  Minute: 'Minutes',
  Hour: 'Hours',
  Day: 'Days',
  MinuteSecond: 'Minutes:Seconds',
  HourMinute: 'Hours:Minutes',
  HourMinuteSecond: 'Hours:Minutes:Seconds',
};

const ExportFieldSettingOptions = {
  DisplayName: 'Export field names',
  DecimalPlaces: 'Export decimal places',
  NegativeSettings: 'Export negative settings',
  SummaryMethod: 'Export summary methods',
  TimespanUnit: 'Export timespan units',
  ListItem: 'Export list items',
};

const DashboardTypes = {
  Simple: 'Simple',
  Carousel: 'Carousel',
  Interactive: 'Interactive',
};

const RestrictionValueTypes = {
  Constant: 'Constant',
  Field: 'Field',
  Date: 'Date value',
  Variable: 'Variable',
  ParentField: 'Parent field',
  FiscalPeriod: 'Fiscal period',
};

const ReportingTreeTypes = {
  CalendarDate: 'Date tree',
  FiscalPeriod: 'Fiscal period tree',
  MultiField: 'Multi-field tree',
};

const ReportingTreeDateLevels = {
  Year: 'Year',
  Quarter: 'Quarter',
  Month: 'Month',
  Day: 'Day',
  Week: 'Week',
  DayOfWeek: 'Day of week',
};

const Themes = {
  Default: 'Default theme',
  Dark: 'Dark theme',
  Dynamics365BusinessCentral: 'Dynamics 365 Business Central',
  Dynamics365Sales: 'Dynamics 365 Sales',
  DynamicsGp: 'Dynamics GP',
  Material: 'Material',
  Netsuite: 'Netsuite',
  Salesforce: 'Salesforce',
  Zendesk: 'Zendesk',
  Acumatica: 'Acumatica',
  HighContrast: 'High contrast',
};

const ActionTypes = {
  OpenUrl: 'Open a website',
  OpenForm: 'Open a form',
  RequestMethod: 'Request API method',
  ConnectorAction: 'Run a connector action',
  SmartConnect: 'Run a SmartConnect integration',
  SendApiRequest: 'Send an API request',
  Flow: 'Trigger a Microsoft Power Automate flow',
};

const JoinMethods = {
  Equals: 'Inner',
  Left: 'Left outer',
  Right: 'Right outer',
  Full: 'Full outer',
  Cross: 'Cross join',
};

const DateSummaryMethods = {
  None: 'None',
  Day: 'Day',
  Month: 'Month',
  Year: 'Year',
};

const GenerateFiscalPeriodMethods = {
  Month: 'Add a period for each month',
  FourWeek: 'Add a period every 4 weeks',
  Week: 'Add a period for each week',
  Quarter: 'Add a period for each quarter',
};

const ColorCodingAppliesToDescriptions = {
  Field: 'Field',
  Row: 'Entire row',
  Group: 'Group',
  DuplicateFieldValue: 'Duplicate field values',
};

const DimensionValueTypes = {
  Code: 'Dimension code',
  Description: 'Description',
};

const AppAvailabilityDescriptions = {
  AllUsers: 'All Popdock users',
  MyCustomers: 'Just my customers',
};

export {
  ActionDisplayTypes,
  ActionTypes,
  ApiRequestMethods,
  AppAvailabilityDescriptions,
  ChartTypes,
  ColorCodingAppliesToDescriptions,
  ConnectorSetupLabels,
  ConnectorSetupMessages,
  ConnectorSetupPlaceholders,
  ConnectorSetupTooltips,
  Countries,
  CustomEntityTypes,
  DashboardTypes,
  DataLakeChunkGranularity,
  DateFormats,
  DateSummaryMethods,
  DateValues,
  DaysOfWeek,
  DimensionValueTypes,
  Explanations,
  ExportFieldSettingOptions,
  FieldTypes,
  FirewallTypes,
  Formats,
  GenerateFiscalPeriodMethods,
  HomePageColors,
  InvoiceLabels,
  JobEmailAttachmentFormats,
  JobTypes,
  JoinMethods,
  Labels,
  Messages,
  MfaAuthenticatorApps,
  MfaInstructions,
  Months,
  Operators,
  PageSizes,
  Permissions,
  Prompts,
  ReportingTreeDateLevels,
  ReportingTreeTypes,
  RestrictionValueTypes,
  ScriptLanguages,
  ShortMonths,
  SidebarWidgetSizes,
  SummaryMethods,
  TextFormats,
  Themes,
  TimespanUnits,
  Tooltips,
  UsStates,
  WidgetParameterTypes,
};
